
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("PJ00O", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $22YGN = parcelRequire("22YGN");


var $hw5V0 = parcelRequire("hw5V0");

const $0a1fd9c7a1f16ff9$export$56985cb4934eb626 = ({ config: props, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const primaryToolbarComponent = ({ editorView: editorView, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $22YGN.default), {
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            editorView: editorView,
            eventDispatcher: eventDispatcher,
            collabEdit: props?.collabEdit,
            takeFullWidth: props?.takeFullWidth,
            featureFlags: featureFlags,
            editorAnalyticsAPI: api?.analytics?.actions,
            editorAPI: api
        });
    };
    if (props.showAvatarGroup) api?.primaryToolbar?.actions.registerComponent({
        name: 'avatarGroup',
        component: primaryToolbarComponent
    });
    return {
        name: 'avatarGroup',
        primaryToolbarComponent: !api?.primaryToolbar && props.showAvatarGroup ? primaryToolbarComponent : undefined,
        actions: {
            getToolbarItem: ({ inviteToEditHandler: inviteToEditHandler, isInviteToEditButtonSelected: isInviteToEditButtonSelected, inviteToEditComponent: inviteToEditComponent })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $hw5V0.default), {
                    featureFlags: api?.featureFlags?.sharedState.currentState() ?? {},
                    editorAnalyticsAPI: api?.analytics?.actions,
                    editorAPI: api,
                    inviteToEditHandler: inviteToEditHandler,
                    isInviteToEditButtonSelected: isInviteToEditButtonSelected,
                    inviteToEditComponent: inviteToEditComponent
                });
            }
        }
    };
};
module.exports["avatarGroupPlugin"] = $0a1fd9c7a1f16ff9$export$56985cb4934eb626;

});

parcelRegister("22YGN", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $8C5kA = parcelRequire("8C5kA");


var $d925B = parcelRequire("d925B");


var $c5kBY = parcelRequire("c5kBY");


var $hw5V0 = parcelRequire("hw5V0");

function $04f8d7f6355f625f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $04f8d7f6355f625f$var$toolbarButtonWrapper = {
    name: "gzuwk4",
    styles: "display:flex;justify-content:flex-end;flex-grow:0;align-items:center;& > div{margin-right:0;}"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $04f8d7f6355f625f$var$toolbarButtonWrapperFullWidth = /*#__PURE__*/ (0, $9K4OG.css)($04f8d7f6355f625f$var$toolbarButtonWrapper, "flex-grow:1;");
const $04f8d7f6355f625f$var$AvatarGroupPluginWrapper = (props)=>{
    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent, featureFlags: featureFlags } = props;
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        if (!dispatchAnalyticsEvent) return;
        dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).VIEWED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AVATAR_GROUP_PLUGIN,
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "aria-label": intl.formatMessage((0, $c5kBY.avatarGroupMessages).editors),
        "data-testid": 'avatar-group-in-plugin',
        css: props.takeFullWidth ? $04f8d7f6355f625f$var$toolbarButtonWrapperFullWidth : $04f8d7f6355f625f$var$toolbarButtonWrapper
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hw5V0.default), {
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        inviteToEditComponent: props.collabEdit && props.collabEdit.inviteToEditComponent,
        inviteToEditHandler: props.collabEdit && props.collabEdit.inviteToEditHandler,
        isInviteToEditButtonSelected: props.collabEdit && props.collabEdit.isInviteToEditButtonSelected,
        featureFlags: featureFlags,
        editorAnalyticsAPI: props.editorAnalyticsAPI,
        editorAPI: props.editorAPI
    }));
};
var $04f8d7f6355f625f$export$2e2bcd8739ae039 = $04f8d7f6355f625f$var$AvatarGroupPluginWrapper;
module.exports["default"] = $04f8d7f6355f625f$export$2e2bcd8739ae039;

});

parcelRegister("hw5V0", function(module, exports) {
$parcel$export(module.exports, "default", () => $239a6f15acd3f564$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $eiA8Z = parcelRequire("eiA8Z");


var $61p3e = parcelRequire("61p3e");


var $9WL6p = parcelRequire("9WL6p");


var $gwi48 = parcelRequire("gwi48");

const $239a6f15acd3f564$var$AvatarsWithPluginState = (props)=>{
    const title = props.intl.formatMessage((0, $61p3e.default).inviteToEditButtonTitle);
    const { isInviteToEditButtonSelected: selected, inviteToEditHandler: onClick, inviteToEditComponent: Component, editorView: editorView, featureFlags: featureFlags, editorAnalyticsAPI: editorAnalyticsAPI, editorAPI: editorAPI } = props;
    const { sessionId: sessionId, activeParticipants: activeParticipants, initialised: initialised } = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'collabEdit'
    ], (states)=>({
            sessionId: states.collabEditState?.sessionId,
            activeParticipants: states.collabEditState?.activeParticipants,
            initialised: states.collabEditState?.initialised
        }));
    if (!initialised) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WL6p.Avatars), {
        sessionId: sessionId,
        participants: activeParticipants,
        editorView: editorView,
        featureFlags: featureFlags,
        editorAnalyticsAPI: editorAnalyticsAPI,
        editorAPI: editorAPI,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gwi48.InviteToEditButton), {
            title: title,
            selected: selected,
            onClick: onClick,
            Component: Component
        })
    });
};
var $239a6f15acd3f564$export$2e2bcd8739ae039 = (0, $gmMgo.default)($239a6f15acd3f564$var$AvatarsWithPluginState);

});

parcelRegister("9WL6p", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2Pg7f = parcelRequire("2Pg7f");


var $d925B = parcelRequire("d925B");


var $ks2lK = parcelRequire("ks2lK");


var $9WuvK = parcelRequire("9WuvK");


var $8yWID = parcelRequire("8yWID");

const $711e821894e7e93e$var$scrollToCollabCursor = (editorAPI, participants, sessionId, index, editorAnalyticsAPI)=>{
    const selectedUser = participants[index];
    const cursorPos = selectedUser.cursorPos;
    if (selectedUser && cursorPos !== undefined && selectedUser.sessionId !== sessionId) {
        const analyticsPayload = {
            action: (0, $d925B.ACTION).MATCHED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).SELECTION,
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        editorAPI?.core?.actions?.execute(({ tr: tr })=>{
            tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(cursorPos)));
            editorAnalyticsAPI?.attachAnalyticsEvent(analyticsPayload)(tr);
            tr.scrollIntoView();
            return tr;
        });
        editorAPI?.core?.actions?.focus();
    }
};
const $711e821894e7e93e$export$8232a93d94178362 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { sessionId: sessionId, featureFlags: featureFlags, editorAPI: editorAPI } = props;
    // .slice() turns ReadonlyArray<CollabParticipant> into a mutable CollabParticipant[]
    const participants = props.participants?.toArray()?.slice();
    if (!participants) return null;
    const avatars = participants.sort((p)=>p.sessionId === sessionId ? -1 : 1).map((participant)=>(0, $8yWID.default)(participant, editorAPI));
    if (!avatars.length) return null;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $9WuvK.avatarContainerStyles)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2Pg7f.default), {
        appearance: "stack",
        size: "medium",
        data: avatars,
        maxCount: 3,
        onAvatarClick: (_event, _analytics, index)=>{
            const allowCollabAvatarScroll = featureFlags?.collabAvatarScroll;
            // user does not need to scroll to their own position (index 0)
            if (allowCollabAvatarScroll && index > 0) $711e821894e7e93e$var$scrollToCollabCursor(editorAPI, participants, props.sessionId, index, props.editorAnalyticsAPI);
        }
    }), props.children));
});
module.exports["Avatars"] = $711e821894e7e93e$export$8232a93d94178362;

});

parcelRegister("9WuvK", function(module, exports) {
/* eslint-disable @repo/internal/styles/no-exported-styles, @atlaskit/design-system/no-nested-styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");


var $6fnsQ = parcelRequire("6fnsQ");

function $849d8d04cecde05d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $849d8d04cecde05d$export$2755d6ea511694ef = /*#__PURE__*/ (0, $9K4OG.css)({
    background: `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`,
    borderRadius: "var(--ds-radius-full, 9999px)",
    minWidth: "var(--ds-space-400, 32px)",
    marginLeft: "var(--ds-space-negative-050, -4px)"
});
const $849d8d04cecde05d$export$84e713f68a1110f7 = {
    name: "1g5siac",
    styles: "margin-right:var(--ds-space-100, 8px);display:flex;align-items:center;&& > ul{list-style-type:none;}div:last-child button.invite-to-edit{border-radius:var(--ds-radius-full, 9999px);height:32px;width:32px;padding:var(--ds-space-025, 2px);}"
};
const $849d8d04cecde05d$export$4aebd143f31d0c0d = (backgroundColor, textColor)=>/*#__PURE__*/ (0, $9K4OG.css)({
        display: 'block',
        position: 'absolute',
        right: "var(--ds-space-025, 2px)",
        bottom: "var(--ds-space-025, 2px)",
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $aFUXX.akEditorSmallZIndex),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: backgroundColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: textColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $aFUXX.relativeFontSizeToBase16)(9),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        paddingTop: "var(--ds-space-075, 6px)",
        textAlign: 'center',
        boxShadow: `0 0 1px ${"var(--ds-border-inverse, #fff)"}`,
        boxSizing: 'border-box'
    });
module.exports["inviteTeamWrapperStyles"] = $849d8d04cecde05d$export$2755d6ea511694ef;
module.exports["avatarContainerStyles"] = $849d8d04cecde05d$export$84e713f68a1110f7;
module.exports["badge"] = $849d8d04cecde05d$export$4aebd143f31d0c0d;

});

parcelRegister("8yWID", function(module, exports) {
$parcel$export(module.exports, "default", () => $aea62b1d5b248950$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $jIIWy = parcelRequire("jIIWy");

const $aea62b1d5b248950$var$toAvatar = (participant, api)=>({
        name: participant.name,
        src: participant.avatar,
        size: 'medium',
        presence: /*#__PURE__*/ (0, $l998X.jsx)((0, $jIIWy.ColoredAvatarItem), {
            api: api,
            name: participant.name,
            sessionId: participant.sessionId,
            presenceId: participant.presenceId
        })
    });
var $aea62b1d5b248950$export$2e2bcd8739ae039 = (0, $2XqLN.default)($aea62b1d5b248950$var$toAvatar, function participantEquals([a], [b]) {
    return a.name === b.name && a.avatar === b.avatar && a.sessionId === b.sessionId;
});

});

parcelRegister("jIIWy", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $6fnsQ = parcelRequire("6fnsQ");


var $9WuvK = parcelRequire("9WuvK");

const $73c72dde0e84c83e$export$1a8ce77350a239fa = (props)=>{
    const participantColor = props.api?.collabEdit?.actions?.getAvatarColor(props.presenceId ?? props.sessionId) ?? {
        backgroundColor: `var(--ds-background-accent-red-subtle, ${0, $6fnsQ.R100})`,
        textColor: `var(--ds-text-accent-gray-bolder, ${0, $6fnsQ.N900})`
    };
    const avatar = props.name.substr(0, 1).toUpperCase();
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $9WuvK.badge)(participantColor?.backgroundColor, participantColor?.textColor),
        "data-testid": "editor-collab-badge"
    }, avatar);
};
module.exports["ColoredAvatarItem"] = $73c72dde0e84c83e$export$1a8ce77350a239fa;

});

parcelRegister("gwi48", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $a4eZN = parcelRequire("a4eZN");


var $g5gZt = parcelRequire("g5gZt");


var $9WuvK = parcelRequire("9WuvK");

const $f0562110382ae1dd$var$ID = (props)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, props.children);
const $f0562110382ae1dd$export$c166df103ee37df9 = (props)=>{
    const { Component: Component, onClick: onClick, selected: selected, title: title } = props;
    const iconBefore = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
            label: title
        }), [
        title
    ]);
    if (!Component && !onClick) return null;
    const Wrapper = Component ? Component : $f0562110382ae1dd$var$ID;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $9WuvK.inviteTeamWrapperStyles)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)(Wrapper, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "invite-to-edit",
        onClick: onClick,
        selected: selected,
        title: title,
        titlePosition: "bottom",
        iconBefore: iconBefore
    }))));
};
module.exports["InviteToEditButton"] = $f0562110382ae1dd$export$c166df103ee37df9;

});

parcelRegister("cpn0f", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $eiA8Z = parcelRequire("eiA8Z");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $5fWH4 = parcelRequire("5fWH4");


var $7dXOP = parcelRequire("7dXOP");


var $65ej1 = parcelRequire("65ej1");


var $1hrpf = parcelRequire("1hrpf");


var $bFFau = parcelRequire("bFFau");


var $jCjGs = parcelRequire("jCjGs");


var $cCuH1 = parcelRequire("cCuH1");


var $iPrfA = parcelRequire("iPrfA");

const $6bd0bec877cc506d$export$df895cff1a8daaf7 = ({ config: annotationProviders, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState();
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $iPrfA.getToolbarComponents)(api, annotationProviders));
    return {
        name: 'annotation',
        marks () {
            return [
                {
                    name: 'annotation',
                    mark: (0, $7dXOP.annotationWithToDOMFix)
                }
            ];
        },
        actions: {
            hasAnyUnResolvedAnnotationInPage: $jCjGs.hasAnyUnResolvedAnnotationInPage,
            stripNonExistingAnnotations: $jCjGs.stripNonExistingAnnotations,
            setInlineCommentDraftState: (0, $5fWH4.setInlineCommentDraftState)(api?.analytics?.actions, annotationProviders?.inlineComment.supportedBlockNodes),
            showCommentForBlockNode: (0, $5fWH4.showInlineCommentForBlockNode)(annotationProviders?.inlineComment.supportedBlockNodes)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $jCjGs.getPluginState)(editorState) || undefined;
            const clonedPluginState = Object.assign({}, pluginState);
            delete clonedPluginState?.featureFlagsPluginState;
            return clonedPluginState;
        },
        pmPlugins: ()=>[
                {
                    name: 'annotation',
                    plugin: ({ dispatch: dispatch })=>{
                        if (annotationProviders) return (0, $65ej1.inlineCommentPlugin)({
                            dispatch: dispatch,
                            provider: annotationProviders.inlineComment,
                            editorAnalyticsAPI: api?.analytics?.actions,
                            featureFlagsPluginState: featureFlags,
                            selectCommentExperience: annotationProviders.selectCommentExperience,
                            viewInlineCommentTraceUFOPress: annotationProviders.viewInlineCommentTraceUFOPress,
                            annotationManager: annotationProviders.annotationManager,
                            api: api
                        });
                        return;
                    }
                },
                {
                    name: 'annotationKeymap',
                    plugin: ()=>{
                        if (annotationProviders) return (0, $1hrpf.keymapPlugin)(api);
                        return;
                    }
                }
            ],
        pluginsOptions: {
            floatingToolbar (state) {
                const pluginState = (0, $jCjGs.getPluginState)(state);
                const bookmark = pluginState?.bookmark;
                if ((0, $bFFau.shouldSuppressFloatingToolbar)({
                    state: state,
                    bookmark: bookmark
                })) return (0, $bFFau.buildSuppressedToolbar)(state, api);
            },
            selectionToolbar (state, intl) {
                if (isToolbarAIFCEnabled) return;
                if (!annotationProviders) return;
                const pluginState = (0, $jCjGs.getPluginState)(state);
                if (pluginState && pluginState.isVisible && !pluginState.bookmark && !pluginState.mouseData.isSelecting) {
                    const { isToolbarAbove: isToolbarAbove, onCommentButtonMount: onCommentButtonMount, getCanAddComments: getCanAddComments, contentType: contentType } = annotationProviders.inlineComment;
                    const toolbarConfig = (0, $bFFau.buildToolbar)(api?.analytics?.actions)({
                        state: state,
                        intl: intl,
                        isToolbarAbove: isToolbarAbove,
                        api: api,
                        createCommentExperience: annotationProviders.createCommentExperience,
                        annotationManager: annotationProviders.annotationManager,
                        onCommentButtonMount: onCommentButtonMount,
                        getCanAddComments: getCanAddComments,
                        contentType: contentType
                    });
                    if (!toolbarConfig) return undefined;
                    else return {
                        ...toolbarConfig,
                        rank: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 1 : undefined
                    };
                }
            }
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            if (!annotationProviders || !editorView || (0, $eTj7Y.isSSR)() && (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true)) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)($6bd0bec877cc506d$var$AnnotationContentComponent, {
                api: api,
                editorView: editorView,
                annotationProviders: annotationProviders,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
const $6bd0bec877cc506d$var$selector = (states)=>{
    return {
        isVisible: states.annotationState?.isVisible,
        selectedAnnotations: states.annotationState?.selectedAnnotations,
        annotations: states.annotationState?.annotations
    };
};
function $6bd0bec877cc506d$var$AnnotationContentComponent({ api: api, editorView: editorView, annotationProviders: annotationProviders, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    const annotationState = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'annotation'
    ], $6bd0bec877cc506d$var$selector);
    // need to explicitly check for false as undefined is also a valid value to continue
    if (annotationState?.isVisible === false) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-editor-popup": "true",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cCuH1.InlineCommentView), {
            providers: annotationProviders,
            editorView: editorView,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            editorAnalyticsAPI: api?.analytics?.actions,
            editorAPI: api
        })
    });
}
module.exports["annotationPlugin"] = $6bd0bec877cc506d$export$df895cff1a8daaf7;

});

parcelRegister("5fWH4", function(module, exports) {

var $cUycv = parcelRequire("cUycv");


var $d925B = parcelRequire("d925B");

var $55QXP = parcelRequire("55QXP");


var $ks2lK = parcelRequire("ks2lK");


var $22oXk = parcelRequire("22oXk");


var $5f8Y6 = parcelRequire("5f8Y6");


var $jCjGs = parcelRequire("jCjGs");


var $6e47J = parcelRequire("6e47J");


var $lVlbe = parcelRequire("lVlbe");


var $8WyWb = parcelRequire("8WyWb");

const $0f9c6d7837321f71$export$4d8462ca3c146d0e = (editorAnalyticsAPI)=>(partialNewState, resolveMethod)=>{
        const command = {
            type: (0, $5f8Y6.ACTIONS).UPDATE_INLINE_COMMENT_STATE,
            data: partialNewState
        };
        const allResolved = Object.values(partialNewState).every((state)=>state);
        // TODO: EDF-716 - This is nuking the scroll into view which occurs
        // when a comment is resolved. The problem is this is called when either a collab user or the current user resolves a comment.
        // and the problem is since cc is just dispatching an event through the provider to resolve the comment and this
        // is not comming via NCS, we have not way to know if this is a local or remote transaction.
        // To quickly fix this problem to unblock live pages this will just stop the transaction causing a scroll when the
        // resolve method is set.
        const transformer = (tr, state)=>resolveMethod === (0, $55QXP.RESOLVE_METHOD).CONSUMER ? tr.setMeta('scrollIntoView', false) : tr;
        if (resolveMethod && allResolved) return (0, $22oXk.createCommand)(command, (tr, state)=>transformer((0, $lVlbe.default).addResolveAnalytics(editorAnalyticsAPI)(resolveMethod)(tr, state), state));
        return (0, $22oXk.createCommand)(command, transformer);
    };
const $0f9c6d7837321f71$export$da26c8d097933b72 = ()=>(0, $22oXk.createCommand)({
        type: (0, $5f8Y6.ACTIONS).CLOSE_COMPONENT
    });
const $0f9c6d7837321f71$export$ffa869a92c2481c3 = ()=>(0, $22oXk.createCommand)({
        type: (0, $5f8Y6.ACTIONS).INLINE_COMMENT_CLEAR_DIRTY_MARK
    });
const $0f9c6d7837321f71$export$a3833f7fc842f6da = ()=>(0, $22oXk.createCommand)({
        type: (0, $5f8Y6.ACTIONS).SET_INLINE_COMMENTS_FETCHED
    });
const $0f9c6d7837321f71$export$940b79a08b19cea6 = (editorAnalyticsAPI)=>(canSetAsSelectedAnnotations, errorReason)=>{
        const command = {
            type: (0, $5f8Y6.ACTIONS).FLUSH_PENDING_SELECTIONS,
            data: {
                canSetAsSelectedAnnotations: canSetAsSelectedAnnotations
            }
        };
        if (!!errorReason) return (0, $22oXk.createCommand)(command, (tr, state)=>(0, $lVlbe.default).addPreemptiveGateErrorAnalytics(editorAnalyticsAPI)(errorReason)(tr, state));
        return (0, $22oXk.createCommand)(command);
    };
const $0f9c6d7837321f71$export$a99e2fe25edc1abd = (id)=>(0, $22oXk.createCommand)({
        type: (0, $5f8Y6.ACTIONS).SET_PENDING_SELECTIONS,
        data: {
            selectedAnnotations: [
                {
                    id: id,
                    type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $0f9c6d7837321f71$var$removeInlineCommentFromNode = (id, supportedBlockNodes = [], state, dispatch)=>{
    const { tr: tr, selection: selection } = state;
    if (selection instanceof (0, $ks2lK.NodeSelection) && (0, $jCjGs.isSupportedBlockNode)(selection.node, supportedBlockNodes)) {
        const { $from: $from } = selection;
        let currNode = selection.node;
        let from = $from.start();
        // for media annotation, the selection is on media Single
        if (currNode.type === state.schema.nodes.mediaSingle && currNode.firstChild) {
            currNode = currNode.firstChild;
            from = from + 1;
        }
        const { annotation: annotationMarkType } = state.schema.marks;
        const hasAnnotation = currNode.marks.some((mark)=>mark.type === annotationMarkType);
        if (!hasAnnotation) return false;
        tr.removeNodeMark(from, annotationMarkType.create({
            id: id,
            type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        }));
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};
const $0f9c6d7837321f71$export$75bee4cee90040 = (id, supportedNodes = [])=>(state, dispatch)=>{
        const { tr: tr, selection: { $from: $from } } = state;
        if ($0f9c6d7837321f71$var$removeInlineCommentFromNode(id, supportedNodes, state, dispatch)) return true;
        const { annotation: annotationMarkType } = state.schema.marks;
        const hasAnnotation = $from.marks().some((mark)=>mark.type === annotationMarkType);
        if (!hasAnnotation) return false;
        // just remove entire mark from around the node
        tr.removeMark($from.start(), $from.end(), annotationMarkType.create({
            id: id,
            type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        }));
        if (dispatch) dispatch(tr);
        return true;
    };
const $0f9c6d7837321f71$export$d087dc0f7213ba13 = (editorAnalyticsAPI)=>(id, supportedNodes = [])=>(state, dispatch)=>{
            const { tr: tr } = state;
            state.doc.descendants((node, pos)=>{
                // Inline comment on mediaInline is not supported as part of comments on media project
                // Thus, we skip the decoration for mediaInline node
                if (node.type.name === 'mediaInline') return false;
                const isSupportedBlockNode = node.isBlock && supportedNodes?.includes(node.type.name);
                node.marks.filter((mark)=>mark.type === state.schema.marks.annotation && mark.attrs.id === id).forEach((mark)=>{
                    if (isSupportedBlockNode) tr.removeNodeMark(pos, mark);
                    else tr.removeMark(pos, pos + node.nodeSize, mark);
                });
            });
            if (dispatch) {
                dispatch((0, $lVlbe.default).addDeleteAnalytics(editorAnalyticsAPI)(tr, state));
                return true;
            }
            return false;
        };
const $0f9c6d7837321f71$var$getDraftCommandAction = (drafting, targetType, targetNodeId, supportedBlockNodes, isOpeningMediaCommentFromToolbar)=>{
    return (editorState)=>{
        // validate selection only when entering draft mode
        if (drafting && (0, $jCjGs.isSelectionValid)(editorState) !== (0, $6e47J.AnnotationSelectionType).VALID) return false;
        return {
            type: (0, $5f8Y6.ACTIONS).SET_INLINE_COMMENT_DRAFT_STATE,
            data: {
                drafting: drafting,
                editorState: editorState,
                targetType: targetType,
                supportedBlockNodes: supportedBlockNodes,
                targetNodeId: targetNodeId,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar
            }
        };
    };
};
const $0f9c6d7837321f71$export$d80af6562490622d = (supportedBlockNodes = [])=>(node, viewMethod, isOpeningMediaCommentFromToolbar)=>(state, dispatch)=>{
            const pluginState = (0, $jCjGs.getPluginState)(state);
            const { annotation: annotation } = state.schema.marks;
            if (node && node.isBlock && supportedBlockNodes.includes(node.type.name)) {
                const unresolvedAnnotationMarks = (node?.marks || []).filter((mark)=>mark.type === annotation && !pluginState?.annotations[mark.attrs.id]).map((mark)=>({
                        id: mark.attrs.id,
                        type: mark.attrs.annotationType
                    }));
                if (unresolvedAnnotationMarks.length) {
                    if (dispatch) {
                        // bypass createCommand with setMeta
                        // so that external plugins can be aware of if there are active(unresolved) comments associated with the node
                        // i.e. media plugin can use the return result (true/false) to show toggle create comment component
                        dispatch(state.tr.setMeta((0, $jCjGs.inlineCommentPluginKey), {
                            type: (0, $5f8Y6.ACTIONS).SET_SELECTED_ANNOTATION,
                            data: {
                                selectedAnnotations: unresolvedAnnotationMarks,
                                selectAnnotationMethod: viewMethod,
                                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar
                            }
                        }));
                        return true;
                    }
                }
            }
            return false;
        };
const $0f9c6d7837321f71$export$2a7aec6fc438fa0b = (editorAnalyticsAPI, supportedBlockNodes = [], api)=>(drafting, inputMethod = (0, $d925B.INPUT_METHOD).TOOLBAR, targetType = 'inline', targetNodeId, isOpeningMediaCommentFromToolbar)=>{
        const commandAction = $0f9c6d7837321f71$var$getDraftCommandAction(drafting, targetType, targetNodeId, supportedBlockNodes, isOpeningMediaCommentFromToolbar);
        if (Boolean(api?.toolbar)) return (state, dispatch)=>{
            const tr = (0, $lVlbe.default).handleDraftState(editorAnalyticsAPI)(drafting, inputMethod)(state.tr, state);
            const newPluginState = commandAction(state);
            if (tr && newPluginState) {
                tr.setMeta((0, $jCjGs.inlineCommentPluginKey), newPluginState);
                if (drafting) (0, $8WyWb.setUserIntent)(api, tr);
                else (0, $8WyWb.resetUserIntent)(api, tr);
                if (dispatch) dispatch(tr);
            } else return false;
            return true;
        };
        else return (0, $22oXk.createCommand)(commandAction, (0, $lVlbe.default).handleDraftState(editorAnalyticsAPI)(drafting, inputMethod));
    };
const $0f9c6d7837321f71$export$fd78ad47ea0892f4 = (editorAnalyticsAPI, editorAPI)=>(id, supportedBlockNodes)=>{
        const commandAction = (editorState)=>({
                type: (0, $5f8Y6.ACTIONS).ADD_INLINE_COMMENT,
                data: {
                    drafting: false,
                    inlineComments: {
                        [id]: false
                    },
                    // Auto make the newly inserted comment selected.
                    // We move the selection to the head of the comment selection.
                    selectedAnnotations: [
                        {
                            id: id,
                            type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
                        }
                    ],
                    editorState: editorState
                }
            });
        if (Boolean(editorAPI?.toolbar)) return (state, dispatch)=>{
            const tr = (0, $lVlbe.default).addInlineComment(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes)(state.tr, state);
            tr.setMeta((0, $jCjGs.inlineCommentPluginKey), commandAction(state));
            (0, $8WyWb.resetUserIntent)(editorAPI, tr);
            if (dispatch) {
                dispatch(tr);
                return true;
            }
            return false;
        };
        else return (0, $22oXk.createCommand)(commandAction, (0, $lVlbe.default).addInlineComment(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes));
    };
const $0f9c6d7837321f71$export$ef4c42f03863dce9 = (mouseData)=>(0, $22oXk.createCommand)({
        type: (0, $5f8Y6.ACTIONS).INLINE_COMMENT_UPDATE_MOUSE_STATE,
        data: {
            mouseData: mouseData
        }
    });
const $0f9c6d7837321f71$export$1e715f68ff6f5a2f = (id)=>(0, $22oXk.createCommand)({
        type: (0, $5f8Y6.ACTIONS).SET_SELECTED_ANNOTATION,
        data: {
            selectedAnnotations: [
                {
                    id: id,
                    type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $0f9c6d7837321f71$export$c1805eee6fd0cf44 = (id)=>(0, $22oXk.createCommand)({
        type: (0, $5f8Y6.ACTIONS).SET_HOVERED_ANNOTATION,
        data: {
            hoveredAnnotations: [
                {
                    id: id,
                    type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $0f9c6d7837321f71$export$51eda81011da4982 = (editorAnalyticsAPI, editorAPI)=>(id, annotationType = (0, $cUycv.AnnotationTypes).INLINE_COMMENT, supportedBlockNodes)=>(state, dispatch)=>{
            // don't try to add if there are is no temp highlight bookmarked
            const { bookmark: bookmark } = (0, $jCjGs.getPluginState)(state) || {};
            if (!bookmark || !dispatch) return false;
            if (annotationType === (0, $cUycv.AnnotationTypes).INLINE_COMMENT) return $0f9c6d7837321f71$export$fd78ad47ea0892f4(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes)(state, dispatch);
            return false;
        };
const $0f9c6d7837321f71$export$c6dc86fb1ced7a07 = (isVisible)=>{
    return (0, $22oXk.createCommand)({
        type: (0, $5f8Y6.ACTIONS).INLINE_COMMENT_SET_VISIBLE,
        data: {
            isVisible: isVisible
        }
    });
};
module.exports["updateInlineCommentResolvedState"] = $0f9c6d7837321f71$export$4d8462ca3c146d0e;
module.exports["closeComponent"] = $0f9c6d7837321f71$export$da26c8d097933b72;
module.exports["clearDirtyMark"] = $0f9c6d7837321f71$export$ffa869a92c2481c3;
module.exports["setInlineCommentsFetched"] = $0f9c6d7837321f71$export$a3833f7fc842f6da;
module.exports["flushPendingSelections"] = $0f9c6d7837321f71$export$940b79a08b19cea6;
module.exports["setPendingSelectedAnnotation"] = $0f9c6d7837321f71$export$a99e2fe25edc1abd;
module.exports["removeInlineCommentNearSelection"] = $0f9c6d7837321f71$export$75bee4cee90040;
module.exports["removeInlineCommentFromDoc"] = $0f9c6d7837321f71$export$d087dc0f7213ba13;
module.exports["showInlineCommentForBlockNode"] = $0f9c6d7837321f71$export$d80af6562490622d;
module.exports["setInlineCommentDraftState"] = $0f9c6d7837321f71$export$2a7aec6fc438fa0b;
module.exports["updateMouseState"] = $0f9c6d7837321f71$export$ef4c42f03863dce9;
module.exports["setSelectedAnnotation"] = $0f9c6d7837321f71$export$1e715f68ff6f5a2f;
module.exports["setHoveredAnnotation"] = $0f9c6d7837321f71$export$c1805eee6fd0cf44;
module.exports["createAnnotation"] = $0f9c6d7837321f71$export$51eda81011da4982;
module.exports["setInlineCommentsVisibility"] = $0f9c6d7837321f71$export$c6dc86fb1ced7a07;

});

parcelRegister("22oXk", function(module, exports) {

var $lkJUe = parcelRequire("lkJUe");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");


var $1oCLl = parcelRequire("1oCLl");


var $6tC18 = parcelRequire("6tC18");


var $jCjGs = parcelRequire("jCjGs");

const $5bbbca891262e1f8$var$handleDocChanged = (tr, prevPluginState)=>{
    if (!tr.getMeta('replaceDocument')) return $5bbbca891262e1f8$var$getSelectionChangedHandler(false)(tr, prevPluginState);
    return {
        ...prevPluginState,
        dirtyAnnotations: true
    };
};
/**
 * Creates a handleDocChanged function with its own deleted annotations cache.
 * This ensures each editor instance has its own cache, avoiding cross-contamination.
 */ const $5bbbca891262e1f8$var$createHandleDocChanged = ()=>{
    // Cache for preserving deleted annotation resolved states through delete/undo cycles
    // This lives in closure scope per editor instance to avoid serialization and reduce state size
    const deletedAnnotationsCache = {};
    return (tr, prevPluginState)=>{
        if (tr.getMeta('replaceDocument')) return {
            ...prevPluginState,
            dirtyAnnotations: true
        };
        const updatedState = $5bbbca891262e1f8$var$getSelectionChangedHandler(false)(tr, prevPluginState);
        // Collect annotation IDs currently in the document
        const annotationIdsInDocument = new Set();
        tr.doc.descendants((node)=>{
            node.marks.forEach((mark)=>{
                if (mark.type.name === 'annotation') annotationIdsInDocument.add(mark.attrs.id);
            });
        });
        const annotationIdsInState = Object.keys(prevPluginState.annotations);
        // Early return if annotations haven't changed
        const annotationsHaveChanged = annotationIdsInDocument.size !== annotationIdsInState.length || annotationIdsInState.some((id)=>!annotationIdsInDocument.has(id));
        if (!annotationsHaveChanged) return updatedState;
        // Cache deleted annotations to be able to restore their resolved states on undo
        const updatedAnnotations = {};
        annotationIdsInState.forEach((id)=>{
            if (!annotationIdsInDocument.has(id)) deletedAnnotationsCache[id] = prevPluginState.annotations[id];
        });
        // Update annotations to match document state, preserving resolved states through delete/undo
        // Only include annotations that have a known resolved state - don't default new annotations to false
        // as this would cause them to briefly appear as unresolved before the provider sets their actual state
        annotationIdsInDocument.forEach((id)=>{
            const knownState = prevPluginState.annotations[id] ?? deletedAnnotationsCache[id];
            if (knownState !== undefined) updatedAnnotations[id] = knownState;
        });
        return {
            ...updatedState,
            annotations: updatedAnnotations
        };
    };
};
const $5bbbca891262e1f8$export$58d7bae3d6fd3076 = (tr, editorState, bookmark)=>{
    if (editorState.selection.empty || !bookmark) return true;
    else if (editorState.selection instanceof (0, $ks2lK.NodeSelection)) {
        const bookmarkSelection = bookmark?.resolve(tr.doc);
        if (bookmarkSelection instanceof (0, $ks2lK.NodeSelection)) {
            const selectionNode = editorState.selection.node;
            const bookmarkNode = bookmarkSelection.node;
            /**
			 * Currently, after updating the alt text of a mediaSingle node,
			 * the selection moves to the media node.
			 * (then will append a transaction to its parent node)
			 */ if (selectionNode.type.name === 'media' && bookmarkNode.type.name === 'mediaSingle') return !bookmarkNode.firstChild?.eq(selectionNode);
            else return !bookmarkNode.eq(selectionNode);
        }
    }
    // by default we discard bookmark
    return true;
};
const $5bbbca891262e1f8$var$getSelectionChangeHandlerOld = (reopenCommentView)=>(tr, pluginState)=>{
        if (pluginState.skipSelectionHandling) return {
            ...pluginState,
            skipSelectionHandling: false,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        if (// If pluginState.selectedAnnotations is annotations of block node, i.e. when a new comment is created,
        // we keep it as it is so that we can show comment view component with the newly created comment
        (0, $jCjGs.isBlockNodeAnnotationsSelected)(tr.selection, pluginState.selectedAnnotations)) return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        const selectedAnnotations = (0, $jCjGs.findAnnotationsInSelection)(tr.selection, tr.doc);
        if (selectedAnnotations.length === 0) return {
            ...pluginState,
            selectedAnnotations: selectedAnnotations,
            isInlineCommentViewClosed: true,
            selectAnnotationMethod: undefined
        };
        if ((0, $jCjGs.isSelectedAnnotationsChanged)(selectedAnnotations, pluginState.selectedAnnotations)) return {
            ...pluginState,
            selectedAnnotations: selectedAnnotations,
            selectAnnotationMethod: undefined,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            },
            selectAnnotationMethod: undefined
        };
    };
const $5bbbca891262e1f8$var$getSelectionChangeHandlerNew = (reopenCommentView)=>(tr, pluginState)=>{
        if (pluginState.skipSelectionHandling) return {
            ...pluginState,
            skipSelectionHandling: false,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        const selectedAnnotations = (0, $jCjGs.findAnnotationsInSelection)(tr.selection, tr.doc);
        // NOTE: I've left this commented code here as a reference that the previous old code would reset the selected annotations
        // if the selection is empty. If this is no longer needed, we can remove this code.
        // if (selectedAnnotations.length === 0) {
        // 	return {
        // 		...pluginState,
        // 		pendingSelectedAnnotations: selectedAnnotations,
        // 		pendingSelectedAnnotationsUpdateCount:
        // 			pluginState.pendingSelectedAnnotationsUpdateCount + 1,
        // 		isInlineCommentViewClosed: true,
        // 		selectAnnotationMethod: undefined,
        // 	};
        // }
        if ((0, $jCjGs.isSelectedAnnotationsChanged)(selectedAnnotations, pluginState.pendingSelectedAnnotations)) return {
            ...pluginState,
            pendingSelectedAnnotations: selectedAnnotations,
            pendingSelectedAnnotationsUpdateCount: pluginState.pendingSelectedAnnotationsUpdateCount + 1,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            },
            selectAnnotationMethod: undefined
        };
    };
const $5bbbca891262e1f8$var$getSelectionChangedHandler = (reopenCommentView)=>(tr, pluginState)=>pluginState.isAnnotationManagerEnabled ? $5bbbca891262e1f8$var$getSelectionChangeHandlerNew(reopenCommentView)(tr, pluginState) : $5bbbca891262e1f8$var$getSelectionChangeHandlerOld(reopenCommentView)(tr, pluginState);
// Create the handler with cache once at module level
const $5bbbca891262e1f8$var$handleDocChangedWithSync = $5bbbca891262e1f8$var$createHandleDocChanged();
const $5bbbca891262e1f8$var$getDocChangedHandler = (tr, prevPluginState)=>{
    // Check feature flag at runtime to support test variants
    if ((0, $1oCLl.expValEquals)('platform_editor_annotations_sync_on_docchange', 'isEnabled', true)) return $5bbbca891262e1f8$var$handleDocChangedWithSync(tr, prevPluginState);
    return $5bbbca891262e1f8$var$handleDocChanged(tr, prevPluginState);
};
const { createPluginState: $5bbbca891262e1f8$export$656c7661095efe2e, createCommand: $5bbbca891262e1f8$export$8d4021544bdece00 } = (0, $lkJUe.pluginFactory)((0, $jCjGs.inlineCommentPluginKey), (0, $6tC18.default), {
    onSelectionChanged: $5bbbca891262e1f8$var$getSelectionChangedHandler(true),
    onDocChanged: $5bbbca891262e1f8$var$getDocChangedHandler,
    mapping: (tr, pluginState, editorState)=>{
        const { draftDecorationSet: draftDecorationSet, bookmark: bookmark } = pluginState;
        let mappedDecorationSet = (0, $ftzrq.DecorationSet).empty, mappedBookmark;
        let hasMappedDecorations = false;
        if (draftDecorationSet) mappedDecorationSet = draftDecorationSet.map(tr.mapping, tr.doc);
        hasMappedDecorations = mappedDecorationSet.find(undefined, undefined, (spec)=>Object.values((0, $jCjGs.decorationKey)).includes(spec.key)).length > 0;
        // When changes to decoration target make decoration invalid (e.g. delete text, add mark to node),
        // we need to reset bookmark to hide create component and to avoid invalid draft being published
        // We only perform this change when document selection has changed.
        if (!hasMappedDecorations && $5bbbca891262e1f8$export$58d7bae3d6fd3076(tr, editorState, bookmark)) return {
            ...pluginState,
            draftDecorationSet: mappedDecorationSet,
            bookmark: undefined
        };
        if (bookmark) mappedBookmark = bookmark.map(tr.mapping);
        // return same pluginState if mappings did not change
        if (mappedBookmark === bookmark && mappedDecorationSet === draftDecorationSet) return pluginState;
        return {
            ...pluginState,
            draftDecorationSet: mappedDecorationSet,
            bookmark: mappedBookmark
        };
    }
});
module.exports["createPluginState"] = $5bbbca891262e1f8$export$656c7661095efe2e;
module.exports["createCommand"] = $5bbbca891262e1f8$export$8d4021544bdece00;

});

parcelRegister("6tC18", function(module, exports) {
$parcel$export(module.exports, "default", () => $a74378346bd8522b$export$2e2bcd8739ae039);

var $ftzrq = parcelRequire("ftzrq");


var $5f8Y6 = parcelRequire("5f8Y6");


var $jCjGs = parcelRequire("jCjGs");

var $a74378346bd8522b$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case (0, $5f8Y6.ACTIONS).SET_INLINE_COMMENTS_FETCHED:
            return {
                ...pluginState,
                annotationsLoaded: true
            };
        case (0, $5f8Y6.ACTIONS).UPDATE_INLINE_COMMENT_STATE:
            return {
                ...pluginState,
                annotationsLoaded: true,
                annotations: {
                    ...pluginState.annotations,
                    ...action.data
                }
            };
        case (0, $5f8Y6.ACTIONS).INLINE_COMMENT_UPDATE_MOUSE_STATE:
            const mouseData = Object.assign({}, pluginState.mouseData, action.data.mouseData);
            return {
                ...pluginState,
                mouseData: mouseData
            };
        case (0, $5f8Y6.ACTIONS).SET_INLINE_COMMENT_DRAFT_STATE:
            return $a74378346bd8522b$var$getNewDraftState(pluginState, action.data.drafting, action.data.editorState, action.data.targetType, action.data.supportedBlockNodes, action.data.targetNodeId, action.data.isOpeningMediaCommentFromToolbar);
        case (0, $5f8Y6.ACTIONS).INLINE_COMMENT_CLEAR_DIRTY_MARK:
            return {
                ...pluginState,
                dirtyAnnotations: false,
                annotations: {}
            };
        case (0, $5f8Y6.ACTIONS).CLOSE_COMPONENT:
            return {
                ...pluginState,
                isInlineCommentViewClosed: true,
                isDrafting: false,
                isOpeningMediaCommentFromToolbar: false,
                selectedAnnotations: []
            };
        case (0, $5f8Y6.ACTIONS).ADD_INLINE_COMMENT:
            const updatedPluginState = $a74378346bd8522b$var$getNewDraftState(pluginState, action.data.drafting, action.data.editorState);
            return {
                ...updatedPluginState,
                selectedAnnotations: [
                    ...updatedPluginState.selectedAnnotations,
                    ...action.data.selectedAnnotations
                ],
                annotations: {
                    ...pluginState.annotations,
                    ...action.data.inlineComments
                },
                isInlineCommentViewClosed: false,
                selectAnnotationMethod: undefined,
                ...pluginState.isAnnotationManagerEnabled && {
                    skipSelectionHandling: true
                }
            };
        case (0, $5f8Y6.ACTIONS).INLINE_COMMENT_SET_VISIBLE:
            const { isVisible: isVisible } = action.data;
            if (isVisible === pluginState.isVisible) return pluginState;
            return {
                ...isVisible ? pluginState : $a74378346bd8522b$var$getNewDraftState(pluginState, false),
                isVisible: isVisible
            };
        case (0, $5f8Y6.ACTIONS).SET_SELECTED_ANNOTATION:
            return {
                ...pluginState,
                selectedAnnotations: [
                    ...action.data.selectedAnnotations
                ],
                selectAnnotationMethod: action.data.selectAnnotationMethod,
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false,
                isOpeningMediaCommentFromToolbar: action.data.isOpeningMediaCommentFromToolbar
            };
        case (0, $5f8Y6.ACTIONS).SET_HOVERED_ANNOTATION:
            return {
                ...pluginState,
                hoveredAnnotations: [
                    ...action.data.hoveredAnnotations
                ],
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false
            };
        case (0, $5f8Y6.ACTIONS).FLUSH_PENDING_SELECTIONS:
            return {
                ...pluginState,
                selectedAnnotations: action.data.canSetAsSelectedAnnotations ? [
                    ...pluginState.pendingSelectedAnnotations
                ] : pluginState.selectedAnnotations,
                pendingSelectedAnnotations: [],
                isInlineCommentViewClosed: false
            };
        case (0, $5f8Y6.ACTIONS).SET_PENDING_SELECTIONS:
            return {
                ...pluginState,
                pendingSelectedAnnotations: [
                    ...action.data.selectedAnnotations
                ],
                pendingSelectedAnnotationsUpdateCount: pluginState.pendingSelectedAnnotationsUpdateCount + 1,
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false
            };
        default:
            return pluginState;
    }
};
function $a74378346bd8522b$var$getNewDraftState(pluginState, drafting, editorState, targetType, supportedBlockNodes, targetNodeId, isOpeningMediaCommentFromToolbar) {
    let { draftDecorationSet: draftDecorationSet } = pluginState;
    if (!draftDecorationSet || !drafting) draftDecorationSet = (0, $ftzrq.DecorationSet).empty;
    const newState = {
        ...pluginState,
        draftDecorationSet: draftDecorationSet,
        isDrafting: drafting,
        targetNodeId: targetNodeId
    };
    newState.bookmark = undefined;
    if (drafting && editorState) {
        newState.bookmark = editorState.selection.getBookmark();
        const { from: from, to: to } = (0, $jCjGs.resolveDraftBookmark)(editorState, newState.bookmark, supportedBlockNodes);
        const draftDecoration = (0, $jCjGs.addDraftDecoration)(from, to, targetType);
        newState.draftDecorationSet = draftDecorationSet.add(editorState.doc, [
            draftDecoration
        ]);
    }
    newState.isOpeningMediaCommentFromToolbar = isOpeningMediaCommentFromToolbar;
    return newState;
}

});

parcelRegister("5f8Y6", function(module, exports) {
var $d39172ac82b8477b$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["UPDATE_INLINE_COMMENT_STATE"] = 0] = "UPDATE_INLINE_COMMENT_STATE";
    ACTIONS[ACTIONS["SET_INLINE_COMMENT_DRAFT_STATE"] = 1] = "SET_INLINE_COMMENT_DRAFT_STATE";
    ACTIONS[ACTIONS["INLINE_COMMENT_UPDATE_MOUSE_STATE"] = 2] = "INLINE_COMMENT_UPDATE_MOUSE_STATE";
    ACTIONS[ACTIONS["INLINE_COMMENT_CLEAR_DIRTY_MARK"] = 3] = "INLINE_COMMENT_CLEAR_DIRTY_MARK";
    ACTIONS[ACTIONS["ADD_INLINE_COMMENT"] = 4] = "ADD_INLINE_COMMENT";
    ACTIONS[ACTIONS["INLINE_COMMENT_SET_VISIBLE"] = 5] = "INLINE_COMMENT_SET_VISIBLE";
    ACTIONS[ACTIONS["CLOSE_COMPONENT"] = 6] = "CLOSE_COMPONENT";
    ACTIONS[ACTIONS["SET_SELECTED_ANNOTATION"] = 7] = "SET_SELECTED_ANNOTATION";
    ACTIONS[ACTIONS["SET_HOVERED_ANNOTATION"] = 8] = "SET_HOVERED_ANNOTATION";
    ACTIONS[ACTIONS["FLUSH_PENDING_SELECTIONS"] = 9] = "FLUSH_PENDING_SELECTIONS";
    ACTIONS[ACTIONS["SET_PENDING_SELECTIONS"] = 10] = "SET_PENDING_SELECTIONS";
    ACTIONS[ACTIONS["SET_INLINE_COMMENTS_FETCHED"] = 11] = "SET_INLINE_COMMENTS_FETCHED";
    return ACTIONS;
}({});
module.exports["ACTIONS"] = $d39172ac82b8477b$export$92a1a3b7554e9387;

});

parcelRegister("jCjGs", function(module, exports) {

var $cUycv = parcelRequire("cUycv");


var $d925B = parcelRequire("d925B");


var $kfJSC = parcelRequire("kfJSC");


var $6ESsx = parcelRequire("6ESsx");


var $bYZ53 = parcelRequire("bYZ53");

var $7iE7T = parcelRequire("7iE7T");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");


var $dh538 = parcelRequire("dh538");


var $6e47J = parcelRequire("6e47J");

function $1c6cc12c1e03ecad$var$sum(arr, f) {
    return arr.reduce((val, x)=>val + f(x), 0);
}
const $1c6cc12c1e03ecad$export$c023470e9a462982 = ($pos)=>{
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
    const markNodeBefore = nodeBefore && $pos.doc.nodeAt(Math.max(0, $pos.pos - nodeBefore.nodeSize - 1));
    const markNodeAfter = nodeAfter && $pos.doc.nodeAt($pos.pos + nodeAfter.nodeSize);
    return [
        markNodeBefore && markNodeBefore.marks || [],
        markNodeAfter && markNodeAfter.marks || []
    ];
};
/**
 * Finds annotation marks, and returns their IDs.
 * @param marks Array of marks to search in
 */ const $1c6cc12c1e03ecad$var$filterAnnotationIds = (marks)=>{
    if (!marks.length) return [];
    const { annotation: annotation } = marks[0].type.schema.marks;
    return marks.filter((mark)=>mark.type === annotation).map((mark)=>mark.attrs.id);
};
/**
 * Re-orders the annotation array based on the order in the document.
 *
 * This places the marks that do not appear in the surrounding nodes
 * higher in the list. That is, the inner-most one appears first.
 *
 * Undo, for example, can re-order annotation marks in the document.
 * @param annotations annotation metadata
 * @param $from location to look around (usually the selection)
 */ const $1c6cc12c1e03ecad$var$reorderAnnotations = (annotations, $from)=>{
    const idSet = $1c6cc12c1e03ecad$export$c023470e9a462982($from).map($1c6cc12c1e03ecad$var$filterAnnotationIds);
    annotations.sort((a, b)=>$1c6cc12c1e03ecad$var$sum(idSet, (ids)=>ids.indexOf(a.id)) - $1c6cc12c1e03ecad$var$sum(idSet, (ids)=>ids.indexOf(b.id)));
};
const $1c6cc12c1e03ecad$export$2ecc008effaefd6e = (doc)=>{
    const allAnnotationIds = new Set();
    doc.descendants((node)=>{
        node.marks.filter((mark)=>mark.type.name === 'annotation')// filter out annotations with invalid attributes as they cause errors when interacting with them
        .filter($1c6cc12c1e03ecad$var$validateAnnotationMark).forEach((m)=>allAnnotationIds.add(m.attrs.id));
        return true;
    });
    return Array.from(allAnnotationIds);
};
/*
 * verifies if annotation mark contains valid attributes
 */ const $1c6cc12c1e03ecad$var$validateAnnotationMark = (annotationMark)=>{
    const { id: id, annotationType: annotationType } = annotationMark.attrs;
    return validateAnnotationId(id) && validateAnnotationType(annotationType);
    function validateAnnotationId(id) {
        if (!id || typeof id !== 'string') return false;
        const invalidIds = [
            'null',
            'undefined'
        ];
        return !invalidIds.includes(id.toLowerCase());
    }
    function validateAnnotationType(type) {
        if (!type || typeof type !== 'string') return false;
        const allowedTypes = Object.values((0, $cUycv.AnnotationTypes));
        return allowedTypes.includes(type);
    }
};
const $1c6cc12c1e03ecad$export$824a8ce0be7d4e38 = {
    block: 'blockCommentDecoration',
    inline: 'inlineCommentDecoration'
};
const $1c6cc12c1e03ecad$export$b3b680ab7872fa4c = (start, end, targetType = 'inline')=>{
    if (targetType === 'block') return (0, $ftzrq.Decoration).node(start, end, {
        class: `${(0, $6ESsx.BlockAnnotationSharedClassNames).draft}`
    }, {
        key: $1c6cc12c1e03ecad$export$824a8ce0be7d4e38.block
    });
    return (0, $ftzrq.Decoration).inline(start, end, {
        class: `${(0, $6ESsx.AnnotationSharedClassNames).draft}`
    }, {
        key: $1c6cc12c1e03ecad$export$824a8ce0be7d4e38.inline
    });
};
const $1c6cc12c1e03ecad$export$1832a9899106877a = (annotations)=>{
    const keys = annotations.map((mark)=>mark.id).join('_');
    return `view-annotation-wrapper_${keys}`;
};
const $1c6cc12c1e03ecad$export$3bf994b39b13856a = (selection, doc)=>{
    const { empty: empty, $anchor: $anchor, anchor: anchor } = selection;
    // Only detect annotations on caret selection
    if (!empty || !doc) {
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (selection instanceof (0, $ks2lK.NodeSelection) && [
                'inlineCard',
                'emoji',
                'date',
                'mention',
                'status'
            ].includes(selection.node.type.name)) ;
            else return [];
        } else return [];
    }
    const node = doc.nodeAt(anchor);
    const nodeBefore = $anchor.nodeBefore;
    if (!node && !nodeBefore) return [];
    // Inline comment on mediaInline is not supported as part of comments on media project
    // Hence, we ignore annotations associated with the node when the cursor is right after/before the node
    if ([
        nodeBefore,
        node
    ].some((node)=>node?.type.name === 'mediaInline')) return [];
    const annotationMark = doc.type.schema.marks.annotation;
    const anchorAnnotationMarks = node?.marks || [];
    let marks = [];
    if (annotationMark.isInSet(anchorAnnotationMarks)) marks = anchorAnnotationMarks;
    if (nodeBefore && annotationMark.isInSet(nodeBefore.marks)) {
        const existingMarkIds = marks.map((m)=>m.attrs.id);
        marks = marks.concat(...nodeBefore.marks.filter((m)=>!existingMarkIds.includes(m.attrs.id)));
    }
    const annotations = marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>({
            id: mark.attrs.id,
            type: mark.attrs.annotationType
        }));
    $1c6cc12c1e03ecad$var$reorderAnnotations(annotations, $anchor);
    return annotations;
};
const $1c6cc12c1e03ecad$export$196f73a7cbac5e80 = (editorState, bookmark, supportedBlockNodes = [])=>{
    const { doc: doc } = editorState;
    const resolvedBookmark = bookmark ? bookmark.resolve(doc) : editorState.selection;
    const { from: from, to: to, head: head } = resolvedBookmark;
    let draftBookmark = {
        from: from,
        to: to,
        head: head,
        isBlockNode: false
    };
    if (resolvedBookmark instanceof (0, $ks2lK.NodeSelection)) {
        // It's possible that annotation is only allowed in child node instead parent (e.g. mediaSingle vs media),
        // thus, we traverse the node to find the first node that supports annotation and return its position
        let nodeFound = false;
        doc.nodesBetween(from, to, (node, pos)=>{
            // if we find the node, breakout the traversal to make sure we always record the first supported node
            if (nodeFound) return false;
            const nodeEndsAt = pos + node.nodeSize;
            if (supportedBlockNodes.includes(node.type.name)) {
                draftBookmark = {
                    from: pos,
                    to: nodeEndsAt,
                    head: nodeEndsAt,
                    isBlockNode: node.isBlock
                };
                nodeFound = true;
                return false;
            }
        });
    }
    return draftBookmark;
};
function $1c6cc12c1e03ecad$export$31c5af77b755d41f(editorState, bookmark) {
    // get positions via saved bookmark if it is available
    // this is to make comments box positioned relative to temporary highlight rather then current selection
    if (bookmark) return bookmark.resolve(editorState.doc);
    return editorState.selection;
}
const $1c6cc12c1e03ecad$export$544b399faf6001b7 = new (0, $ks2lK.PluginKey)('inlineCommentPluginKey');
const $1c6cc12c1e03ecad$export$f05434c51e3762e = (state)=>{
    return $1c6cc12c1e03ecad$export$544b399faf6001b7.getState(state);
};
/**
 * get number of unique annotations within current selection
 */ const $1c6cc12c1e03ecad$var$getAnnotationsInSelectionCount = (state)=>{
    const { from: from, to: to } = state.selection;
    const annotations = (0, $bYZ53.getAnnotationIdsFromRange)({
        from: from,
        to: to
    }, state.doc, state.schema);
    return annotations.length;
};
const $1c6cc12c1e03ecad$export$a28639698c912d2c = (drafting, inputMethod)=>{
    const payload = (state)=>{
        let attributes = {};
        if (drafting) attributes = {
            inputMethod: inputMethod,
            overlap: $1c6cc12c1e03ecad$var$getAnnotationsInSelectionCount(state)
        };
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            const { bookmark: bookmark } = $1c6cc12c1e03ecad$export$f05434c51e3762e(state) || {};
            attributes.inlineNodeNames = (0, $bYZ53.getRangeInlineNodeNames)({
                doc: state.doc,
                pos: $1c6cc12c1e03ecad$export$196f73a7cbac5e80(state, bookmark)
            });
        }
        return {
            action: drafting ? (0, $d925B.ACTION).OPENED : (0, $d925B.ACTION).CLOSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: attributes
        };
    };
    return payload;
};
const $1c6cc12c1e03ecad$export$af7e6fc08350a63d = (state, _supportedNodes = [])=>{
    const { selection: selection } = state;
    const { disallowOnWhitespace: disallowOnWhitespace } = $1c6cc12c1e03ecad$export$f05434c51e3762e(state) || {};
    const allowedInlineNodes = [
        'emoji',
        'status',
        'date',
        'mention',
        'inlineCard'
    ];
    const isSelectionEmpty = selection.empty;
    const isTextOrAllSelection = selection instanceof (0, $ks2lK.TextSelection) || selection instanceof (0, $ks2lK.AllSelection);
    const isValidNodeSelection = selection instanceof (0, $ks2lK.NodeSelection) && allowedInlineNodes.includes(selection.node.type.name);
    const isValidSelection = isTextOrAllSelection || isValidNodeSelection;
    // Allow media so that it can enter draft mode
    if ((0, $kfJSC.currentMediaNodeWithPos)(state)?.node) return (0, $6e47J.AnnotationSelectionType).VALID;
    if (isSelectionEmpty || !isValidSelection) return (0, $6e47J.AnnotationSelectionType).INVALID;
    const containsInvalidNodes = $1c6cc12c1e03ecad$export$d454546510357a0(state);
    // A selection that only covers 1 pos, and is an invalid node
    // e.g. a text selection over a mention
    if (containsInvalidNodes && selection.to - selection.from === 1) return (0, $6e47J.AnnotationSelectionType).INVALID;
    if (containsInvalidNodes) return (0, $6e47J.AnnotationSelectionType).DISABLED;
    if (disallowOnWhitespace && $1c6cc12c1e03ecad$export$6d32268ea00f42b0(selection, state.schema)) return (0, $6e47J.AnnotationSelectionType).INVALID;
    if (!(selection instanceof (0, $ks2lK.NodeSelection)) && (0, $bYZ53.isEmptyTextSelection)(selection, state.schema)) return (0, $6e47J.AnnotationSelectionType).INVALID;
    return (0, $6e47J.AnnotationSelectionType).VALID;
};
const $1c6cc12c1e03ecad$export$d454546510357a0 = (state)=>{
    const { selection: selection, doc: doc, schema: schema } = state;
    return !(0, $bYZ53.canApplyAnnotationOnRange)({
        from: selection.from,
        to: selection.to
    }, doc, schema);
};
const $1c6cc12c1e03ecad$export$bb7c9ea7da92cd01 = (node, supportedBlockNodes = [])=>{
    return supportedBlockNodes.indexOf(node.type.name) >= 0 || node.type.name === 'mediaSingle' && supportedBlockNodes.indexOf('media') >= 0;
};
function $1c6cc12c1e03ecad$export$6d32268ea00f42b0(selection, schema) {
    let foundInvalidWhitespace = false;
    const content = selection.content().content;
    let hasCommentableInlineNodeDescendants = false;
    let hasCommentableTextNodeDescendants = false;
    content.descendants((node)=>{
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (isAllowedInlineNode) {
                hasCommentableInlineNodeDescendants = true;
                return false;
            }
        }
        if (node.type === schema.nodes.inlineCard && (0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) return false;
        if ((0, $7iE7T.isText)(node, schema)) {
            if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
                if (node.textContent.trim() !== '') hasCommentableTextNodeDescendants = true;
            }
            return false;
        }
        if (!(0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.textContent.trim() === '') {
                // Trailing new lines do not result in the annotation spanning into
                // the trailing new line so can be ignored when looking for invalid
                // whitespace nodes.
                const nodeIsTrailingNewLine = // it is the final node
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                node.eq(content.lastChild) && // and there are multiple nodes
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !node.eq(content.firstChild) && // and it is a paragraph node
                (0, $7iE7T.isParagraph)(node, schema);
                if (!nodeIsTrailingNewLine) foundInvalidWhitespace = true;
            }
        }
        return !foundInvalidWhitespace;
    });
    if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
        if (hasCommentableInlineNodeDescendants) return false;
        return !hasCommentableTextNodeDescendants;
    }
    return foundInvalidWhitespace;
}
function $1c6cc12c1e03ecad$export$5a8abbb22a9cfbef(annotationId, state) {
    const commentsPluginState = $1c6cc12c1e03ecad$export$f05434c51e3762e(state);
    return !!commentsPluginState?.annotations && Object.keys(commentsPluginState.annotations).includes(annotationId);
}
function $1c6cc12c1e03ecad$export$ca9ec32b395faf65(slice, state) {
    if (!slice.content.size) return false;
    slice.content.forEach((node)=>{
        $1c6cc12c1e03ecad$var$stripNonExistingAnnotationsFromNode(node, state);
        node.content.descendants((node)=>{
            $1c6cc12c1e03ecad$var$stripNonExistingAnnotationsFromNode(node, state);
            return true;
        });
    });
}
/*
 * remove annotations that dont exsist in plugin state
 * from node
 */ function $1c6cc12c1e03ecad$var$stripNonExistingAnnotationsFromNode(node, state) {
    if ((0, $bYZ53.hasAnnotationMark)(node, state)) node.marks = node.marks.filter((mark)=>{
        if (mark.type.name === 'annotation') return $1c6cc12c1e03ecad$export$5a8abbb22a9cfbef(mark.attrs.id, state);
        return true;
    });
    return node;
}
function $1c6cc12c1e03ecad$export$a411569b9111c88e(oldSelectedAnnotations, newSelectedAnnotations) {
    return newSelectedAnnotations.length !== oldSelectedAnnotations.length || // assuming annotations have unique id's for simplicity
    newSelectedAnnotations.some((annotation)=>!oldSelectedAnnotations.find((pluginStateAnnotation)=>annotation.id === pluginStateAnnotation.id && annotation.type === pluginStateAnnotation.type));
}
const $1c6cc12c1e03ecad$export$e171deb7d9f0a865 = (selection, selectedAnnotations = [])=>{
    if (selectedAnnotations.length && selection instanceof (0, $ks2lK.NodeSelection)) {
        const node = selection.node.type.name === 'mediaSingle' ? selection.node.firstChild : selection.node;
        const annotationMarks = node?.marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>({
                id: mark.attrs.id,
                type: mark.attrs.annotationType
            })) || [];
        return !selectedAnnotations.some((annotation)=>!annotationMarks.find((existingAnnotation)=>existingAnnotation.id === annotation.id && existingAnnotation.type === annotation.type));
    }
    return false;
};
const $1c6cc12c1e03ecad$export$98b0a2a6ba343064 = (state)=>{
    const annotations = $1c6cc12c1e03ecad$export$f05434c51e3762e(state)?.annotations;
    if (annotations) {
        /**
     * annotations type is { [key: string]: boolean };
     * Here, key represents mark.attr.id and it is used to find where annotation to be presented in the document.
     * When value is false, it means it is unresolved annotation.
     *
     * But sometimes annotation map has entry with key undefined somehow.
     * And it is not valid mark attribute id, so it won't be presented anywhere in the document.
     */ const unresolvedAnnotationKeys = Object.keys(annotations).filter((key)=>key !== 'undefined' && annotations[key] === false);
        return unresolvedAnnotationKeys.length > 0;
    }
    return false;
};
module.exports["getAllAnnotations"] = $1c6cc12c1e03ecad$export$2ecc008effaefd6e;
module.exports["decorationKey"] = $1c6cc12c1e03ecad$export$824a8ce0be7d4e38;
module.exports["addDraftDecoration"] = $1c6cc12c1e03ecad$export$b3b680ab7872fa4c;
module.exports["getAnnotationViewKey"] = $1c6cc12c1e03ecad$export$1832a9899106877a;
module.exports["findAnnotationsInSelection"] = $1c6cc12c1e03ecad$export$3bf994b39b13856a;
module.exports["resolveDraftBookmark"] = $1c6cc12c1e03ecad$export$196f73a7cbac5e80;
module.exports["getSelectionPositions"] = $1c6cc12c1e03ecad$export$31c5af77b755d41f;
module.exports["inlineCommentPluginKey"] = $1c6cc12c1e03ecad$export$544b399faf6001b7;
module.exports["getPluginState"] = $1c6cc12c1e03ecad$export$f05434c51e3762e;
module.exports["getDraftCommandAnalyticsPayload"] = $1c6cc12c1e03ecad$export$a28639698c912d2c;
module.exports["isSelectionValid"] = $1c6cc12c1e03ecad$export$af7e6fc08350a63d;
module.exports["isSupportedBlockNode"] = $1c6cc12c1e03ecad$export$bb7c9ea7da92cd01;
module.exports["stripNonExistingAnnotations"] = $1c6cc12c1e03ecad$export$ca9ec32b395faf65;
module.exports["isSelectedAnnotationsChanged"] = $1c6cc12c1e03ecad$export$a411569b9111c88e;
module.exports["isBlockNodeAnnotationsSelected"] = $1c6cc12c1e03ecad$export$e171deb7d9f0a865;
module.exports["hasAnyUnResolvedAnnotationInPage"] = $1c6cc12c1e03ecad$export$98b0a2a6ba343064;

});

parcelRegister("6e47J", function(module, exports) {
var $6ec66a5f4782e56b$export$ad08e20e7e22e394 = /*#__PURE__*/ function(AnnotationSelectionType) {
    AnnotationSelectionType["INVALID"] = "invalid";
    AnnotationSelectionType["DISABLED"] = "disabled";
    AnnotationSelectionType["VALID"] = "valid";
    return AnnotationSelectionType;
}({});
const $6ec66a5f4782e56b$var$prefix = 'ak-editor-annotation';
const $6ec66a5f4782e56b$export$711f43d01b7e0019 = {
    prefix: $6ec66a5f4782e56b$var$prefix,
    floatingComponent: `${$6ec66a5f4782e56b$var$prefix}-floating-component`,
    floatingToolbarCreateButton: `${$6ec66a5f4782e56b$var$prefix}-toolbar-create-button`,
    componentSave: `${$6ec66a5f4782e56b$var$prefix}-dummy-save-button`,
    componentClose: `${$6ec66a5f4782e56b$var$prefix}-dummy-close-button`
};
module.exports["AnnotationSelectionType"] = $6ec66a5f4782e56b$export$ad08e20e7e22e394;
module.exports["AnnotationTestIds"] = $6ec66a5f4782e56b$export$711f43d01b7e0019;

});

parcelRegister("lVlbe", function(module, exports) {
$parcel$export(module.exports, "default", () => $525475292fc461c8$export$2e2bcd8739ae039);

var $cUycv = parcelRequire("cUycv");


var $d925B = parcelRequire("d925B");


var $b167b = parcelRequire("b167b");


var $bYZ53 = parcelRequire("bYZ53");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $dh538 = parcelRequire("dh538");


var $jCjGs = parcelRequire("jCjGs");

const $525475292fc461c8$var$isAnnotationStep = (step)=>step instanceof (0, $aXG5V.AddMarkStep) && step.mark.type.name === 'annotation';
const $525475292fc461c8$var$addAnnotationMark = (id, supportedBlockNodes)=>(transaction, state)=>{
        const inlineCommentState = (0, $jCjGs.getPluginState)(state);
        const { bookmark: bookmark } = inlineCommentState || {};
        const annotationMark = state.schema.marks.annotation.create({
            id: id,
            type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        });
        const { from: from, to: to, head: head, isBlockNode: isBlockNode } = (0, $jCjGs.resolveDraftBookmark)(state, bookmark, supportedBlockNodes);
        let tr = transaction;
        if (isBlockNode) {
            tr = tr.addNodeMark(from, annotationMark);
            // Set selection on the node so that we can display view component
            tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, from));
        } else {
            // Apply the mark only to text node in the range.
            const tr = (0, $b167b.applyMarkOnRange)(from, to, false, annotationMark, transaction);
            // The mark may not be applied to the current "head" of the bookmark so determine what was applied
            // above and use that instead
            const annotationMarkStep = tr.steps.reverse().find($525475292fc461c8$var$isAnnotationStep);
            const headBasedOnMark = from === head ? annotationMarkStep?.from : annotationMarkStep?.to;
            tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, headBasedOnMark ?? head));
        }
        return tr;
    };
const $525475292fc461c8$var$addInlineComment = (editorAnalyticsAPI, editorAPI)=>(id, supportedBlockNodes)=>(transaction, state)=>{
            let tr = $525475292fc461c8$var$addAnnotationMark(id, supportedBlockNodes)(transaction, state);
            editorAPI?.editorViewModeEffects?.actions.applyViewModeStepAt(tr);
            // add insert analytics step to transaction
            tr = $525475292fc461c8$var$addInsertAnalytics(editorAnalyticsAPI)(tr, state);
            // add close analytics step to transaction
            tr = $525475292fc461c8$var$addOpenCloseAnalytics(editorAnalyticsAPI)(false, (0, $d925B.INPUT_METHOD).TOOLBAR)(tr, state);
            const pluginState = (0, $jCjGs.getPluginState)(state);
            const isAutoScrollBugFixEnabled = pluginState?.featureFlagsPluginState?.commentsOnMediaAutoscrollInEditor;
            if (isAutoScrollBugFixEnabled) // Explicitly disable scrollIntoView as scrolling is handled by CommentSidebar
            tr.setMeta('scrollIntoView', false);
            return tr;
        };
const $525475292fc461c8$var$addOpenCloseAnalytics = (editorAnalyticsAPI)=>(drafting, method = (0, $d925B.INPUT_METHOD).TOOLBAR)=>(transaction, state)=>{
            const draftingPayload = (0, $jCjGs.getDraftCommandAnalyticsPayload)(drafting, method)(state);
            editorAnalyticsAPI?.attachAnalyticsEvent(draftingPayload)(transaction);
            return transaction;
        };
const $525475292fc461c8$var$handleDraftState = (editorAnalyticsAPI)=>(drafting, method = (0, $d925B.INPUT_METHOD).TOOLBAR)=>(transaction, state)=>{
            const tr = $525475292fc461c8$var$addOpenCloseAnalytics(editorAnalyticsAPI)(drafting, method)(transaction, state);
            const pluginState = (0, $jCjGs.getPluginState)(state);
            const isAutoScrollBugFixEnabled = pluginState?.featureFlagsPluginState?.commentsOnMediaAutoscrollInEditor;
            if (isAutoScrollBugFixEnabled) // Explicitly disable scrollIntoView as scrolling is handled by CommentSidebar
            tr.setMeta('scrollIntoView', false);
            return tr;
        };
const $525475292fc461c8$var$addInsertAnalytics = (editorAnalyticsAPI)=>(transaction, state)=>{
        const analyticsEvent = {
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {}
        };
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            const { bookmark: bookmark } = (0, $jCjGs.getPluginState)(state) || {};
            // When this FF is removed we can move the analytics event creation inside of the
            // attachAnalyticsEvent and get type inference for the attributes.
            // @ts-ignore
            analyticsEvent.attributes.inlineNodeNames = (0, $bYZ53.getRangeInlineNodeNames)({
                doc: state.doc,
                pos: (0, $jCjGs.resolveDraftBookmark)(state, bookmark)
            });
        }
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsEvent)(transaction);
        return transaction;
    };
const $525475292fc461c8$var$addResolveAnalytics = (editorAnalyticsAPI)=>(method)=>(transaction, state)=>{
            const resolvedPayload = {
                action: (0, $d925B.ACTION).RESOLVED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    method: method
                }
            };
            editorAnalyticsAPI?.attachAnalyticsEvent(resolvedPayload)(transaction);
            return transaction;
        };
const $525475292fc461c8$var$addPreemptiveGateErrorAnalytics = (editorAnalyticsAPI)=>(errorReason)=>(transaction, state)=>{
            const analyticsEvent = {
                action: (0, $d925B.ACTION).ERROR,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorReason: errorReason
                }
            };
            editorAnalyticsAPI?.attachAnalyticsEvent(analyticsEvent)(transaction);
            return transaction;
        };
const $525475292fc461c8$var$addDeleteAnalytics = (editorAnalyticsAPI)=>(transaction, state)=>{
        const analyticsEvent = {
            action: (0, $d925B.ACTION).DELETED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {}
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsEvent)(transaction);
        return transaction;
    };
var $525475292fc461c8$export$2e2bcd8739ae039 = {
    addAnnotationMark: $525475292fc461c8$var$addAnnotationMark,
    addInlineComment: $525475292fc461c8$var$addInlineComment,
    handleDraftState: $525475292fc461c8$var$handleDraftState,
    addOpenCloseAnalytics: $525475292fc461c8$var$addOpenCloseAnalytics,
    addInsertAnalytics: $525475292fc461c8$var$addInsertAnalytics,
    addResolveAnalytics: $525475292fc461c8$var$addResolveAnalytics,
    addPreemptiveGateErrorAnalytics: $525475292fc461c8$var$addPreemptiveGateErrorAnalytics,
    addDeleteAnalytics: $525475292fc461c8$var$addDeleteAnalytics
};

});

parcelRegister("8WyWb", function(module, exports) {
const $20ee3e44c93eaa25$export$2c4e3be4c627582b = (api, tr)=>{
    return api?.userIntent?.commands?.setCurrentUserIntent('commenting')({
        tr: tr
    });
};
const $20ee3e44c93eaa25$export$dc07a25f8edf98a5 = (api, tr)=>{
    return api?.userIntent?.commands?.setCurrentUserIntent('default')({
        tr: tr
    });
};
module.exports["setUserIntent"] = $20ee3e44c93eaa25$export$2c4e3be4c627582b;
module.exports["resetUserIntent"] = $20ee3e44c93eaa25$export$dc07a25f8edf98a5;

});

parcelRegister("7dXOP", function(module, exports) {

var $cUycv = parcelRequire("cUycv");

const $f7a893223e5c2354$export$802ec1d716a6bb1 = {
    ...(0, $cUycv.annotation),
    toDOM: (node)=>{
        return [
            'span',
            {
                // Needs id as a reference point
                id: node.attrs.id,
                // Used to determine if the annotation is active
                annotationType: node.attrs.annotationType,
                // Below are used for prosemirror (ie. copy/paste behaviour)
                'data-mark-type': 'annotation',
                'data-mark-annotation-type': node.attrs.annotationType,
                'data-id': node.attrs.id
            },
            0
        ];
    }
};
module.exports["annotationWithToDOMFix"] = $f7a893223e5c2354$export$802ec1d716a6bb1;

});

parcelRegister("65ej1", function(module, exports) {

var $cUycv = parcelRequire("cUycv");


var $55QXP = parcelRequire("55QXP");


var $1S4f7 = parcelRequire("1S4f7");


var $bYZ53 = parcelRequire("bYZ53");


var $ftzrq = parcelRequire("ftzrq");


var $dh538 = parcelRequire("dh538");


var $5fWH4 = parcelRequire("5fWH4");


var $8WyWb = parcelRequire("8WyWb");


var $aN2Kl = parcelRequire("aN2Kl");


var $j5zAH = parcelRequire("j5zAH");


var $22oXk = parcelRequire("22oXk");


var $bFFau = parcelRequire("bFFau");


var $jCjGs = parcelRequire("jCjGs");

const $5afcd16e23d3e19e$var$fetchProviderStates = async (provider, annotationIds)=>{
    if (!provider || !provider.getState) return {};
    const data = await provider.getState(annotationIds);
    const result = {};
    data.forEach((annotation)=>{
        if (annotation.annotationType === (0, $cUycv.AnnotationTypes).INLINE_COMMENT) result[annotation.id] = annotation.state.resolved;
    });
    return result;
};
// fetchState is unable to return a command as it's runs async and may dispatch at a later time
// Requires `editorView` instead of the decomposition as the async means state may end up stale
const $5afcd16e23d3e19e$var$fetchState = async (provider, annotationIds, editorView, editorAnalyticsAPI)=>{
    const inlineCommentStates = await $5afcd16e23d3e19e$var$fetchProviderStates(provider, annotationIds);
    if (Object.keys(inlineCommentStates).length === 0) {
        const { annotationsLoaded: annotationsLoaded } = (0, $jCjGs.getPluginState)(editorView.state) || {};
        if (!annotationsLoaded && (0, $dh538.fg)('confluence_frontend_new_dangling_comments_ux')) (0, $5fWH4.setInlineCommentsFetched)()(editorView.state, editorView.dispatch);
        return;
    }
    if (editorView.dispatch) (0, $5fWH4.updateInlineCommentResolvedState)(editorAnalyticsAPI)(inlineCommentStates)(editorView.state, editorView.dispatch);
};
const $5afcd16e23d3e19e$var$initialState = (disallowOnWhitespace = false, featureFlagsPluginState, isAnnotationManagerEnabled = false)=>{
    return {
        annotationsLoaded: false,
        annotations: {},
        selectedAnnotations: [],
        hoveredAnnotations: [],
        mouseData: {
            isSelecting: false
        },
        disallowOnWhitespace: disallowOnWhitespace,
        isInlineCommentViewClosed: false,
        isVisible: true,
        skipSelectionHandling: false,
        featureFlagsPluginState: featureFlagsPluginState,
        isDrafting: false,
        pendingSelectedAnnotations: [],
        pendingSelectedAnnotationsUpdateCount: 0,
        isAnnotationManagerEnabled: isAnnotationManagerEnabled
    };
};
const $5afcd16e23d3e19e$var$hideToolbar = (state, dispatch)=>()=>{
        (0, $5fWH4.updateMouseState)({
            isSelecting: true
        })(state, dispatch);
    };
// Subscribe to updates from consumer
const $5afcd16e23d3e19e$var$onResolve = (editorAnalyticsAPI)=>(state, dispatch)=>(annotationId)=>{
            (0, $5fWH4.updateInlineCommentResolvedState)(editorAnalyticsAPI)({
                [annotationId]: true
            }, (0, $55QXP.RESOLVE_METHOD).CONSUMER)(state, dispatch);
        };
const $5afcd16e23d3e19e$var$onUnResolve = (editorAnalyticsAPI)=>(state, dispatch)=>(annotationId)=>{
            (0, $5fWH4.updateInlineCommentResolvedState)(editorAnalyticsAPI)({
                [annotationId]: false
            })(state, dispatch);
        };
const $5afcd16e23d3e19e$var$onMouseUp = (state, dispatch)=>(e)=>{
        const { mouseData: mouseData } = (0, $jCjGs.getPluginState)(state) || {};
        if (mouseData?.isSelecting) (0, $5fWH4.updateMouseState)({
            isSelecting: false
        })(state, dispatch);
    };
const $5afcd16e23d3e19e$var$onSetVisibility = (view)=>(isVisible)=>{
        const { state: state, dispatch: dispatch } = view;
        (0, $5fWH4.setInlineCommentsVisibility)(isVisible)(state, dispatch);
        if (isVisible) // PM retains focus when we click away from the editor.
        // This will restore the visual aspect of the selection,
        // otherwise it will seem a floating toolbar will appear
        // for no reason.
        view.focus();
    };
const $5afcd16e23d3e19e$export$e4aab3acac8f34b = (options)=>{
    const { provider: provider, featureFlagsPluginState: featureFlagsPluginState, annotationManager: annotationManager } = options;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $jCjGs.inlineCommentPluginKey),
        state: (0, $22oXk.createPluginState)(options.dispatch, $5afcd16e23d3e19e$var$initialState(provider.disallowOnWhitespace, featureFlagsPluginState, !!annotationManager)),
        view (editorView) {
            let allowAnnotationFn;
            let startDraftFn;
            let clearDraftFn;
            let applyDraftFn;
            let getDraftFn;
            let setIsAnnotationSelectedFn;
            let setIsAnnotationHoveredFn;
            let clearAnnotationFn;
            if (annotationManager) {
                allowAnnotationFn = (0, $j5zAH.allowAnnotation)(editorView, options);
                startDraftFn = (0, $j5zAH.startDraft)(editorView, options);
                clearDraftFn = (0, $j5zAH.clearDraft)(editorView, options);
                applyDraftFn = (0, $j5zAH.applyDraft)(editorView, options);
                getDraftFn = (0, $j5zAH.getDraft)(editorView, options);
                setIsAnnotationSelectedFn = (0, $j5zAH.setIsAnnotationSelected)(editorView, options);
                setIsAnnotationHoveredFn = (0, $j5zAH.setIsAnnotationHovered)(editorView, options);
                clearAnnotationFn = (0, $j5zAH.clearAnnotation)(editorView, options);
                annotationManager.hook('allowAnnotation', allowAnnotationFn);
                annotationManager.hook('startDraft', startDraftFn);
                annotationManager.hook('clearDraft', clearDraftFn);
                annotationManager.hook('applyDraft', applyDraftFn);
                annotationManager.hook('getDraft', getDraftFn);
                annotationManager.hook('setIsAnnotationSelected', setIsAnnotationSelectedFn);
                annotationManager.hook('setIsAnnotationHovered', setIsAnnotationHoveredFn);
                annotationManager.hook('clearAnnotation', clearAnnotationFn);
            }
            // Get initial state
            // Need to pass `editorView` to mitigate editor state going stale
            $5afcd16e23d3e19e$var$fetchState(provider, (0, $jCjGs.getAllAnnotations)(editorView.state.doc), editorView, options.editorAnalyticsAPI);
            const resolve = (annotationId)=>$5afcd16e23d3e19e$var$onResolve(options.editorAnalyticsAPI)(editorView.state, editorView.dispatch)(annotationId);
            const unResolve = (annotationId)=>$5afcd16e23d3e19e$var$onUnResolve(options.editorAnalyticsAPI)(editorView.state, editorView.dispatch)(annotationId);
            const mouseUp = (event)=>$5afcd16e23d3e19e$var$onMouseUp(editorView.state, editorView.dispatch)(event);
            const setVisibility = (isVisible)=>$5afcd16e23d3e19e$var$onSetVisibility(editorView)(isVisible);
            const setSelectedAnnotationFn = (annotationId)=>{
                if (!annotationId) (0, $5fWH4.closeComponent)()(editorView.state, editorView.dispatch);
                else (0, $5fWH4.setSelectedAnnotation)(annotationId)(editorView.state, editorView.dispatch);
            };
            const setHoveredAnnotationFn = (annotationId)=>{
                if (!annotationId) (0, $5fWH4.closeComponent)()(editorView.state, editorView.dispatch);
                else (0, $5fWH4.setHoveredAnnotation)(annotationId)(editorView.state, editorView.dispatch);
            };
            const removeHoveredannotationFn = ()=>{
                (0, $5fWH4.setHoveredAnnotation)('')(editorView.state, editorView.dispatch);
            };
            const closeInlineCommentFn = ()=>{
                (0, $5fWH4.closeComponent)()(editorView.state, editorView.dispatch);
            };
            const { updateSubscriber: updateSubscriber } = provider;
            if (updateSubscriber) updateSubscriber.on('resolve', resolve).on('delete', resolve).on('unresolve', unResolve).on('create', unResolve).on('setvisibility', setVisibility).on('setselectedannotation', setSelectedAnnotationFn).on('sethoveredannotation', setHoveredAnnotationFn).on('removehoveredannotation', removeHoveredannotationFn).on('closeinlinecomment', closeInlineCommentFn);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorView.root.addEventListener('mouseup', mouseUp);
            /**
       * This flag is used to prevent the preemptive gate from being called multiple times while a check is in-flight.
       * If a check is still pending then it's most likely because the product is busy and trying to block the
       * selection of an annotation.
       */ let isPreemptiveGateActive = false;
            return {
                update (view, _prevState) {
                    const { selectedAnnotations: selectedAnnotations, annotations: annotations, isDrafting: isDrafting, bookmark: bookmark } = (0, $jCjGs.getPluginState)(view.state) || {};
                    const { selectedAnnotations: prevSelectedAnnotations } = (0, $jCjGs.getPluginState)(_prevState) || {};
                    const selectedAnnotationId = selectedAnnotations && selectedAnnotations.length !== 0 && selectedAnnotations[0].id ? selectedAnnotations[0].id : undefined;
                    // If the new state has an unresolved selected annotation, and it's different from
                    // the previous one then...
                    if (//This checks the selected annotation is different from the previous one
                    selectedAnnotationId && selectedAnnotationId !== prevSelectedAnnotations?.[0]?.id && // This ensures that the selected annotation is unresolved
                    annotations && annotations[selectedAnnotationId] === false) {
                        // ...we mark the select annotation experience as complete.
                        // The selectComponentExperience is using a simplified object, which is why it's type asserted.
                        options.selectCommentExperience?.selectAnnotation.complete(selectedAnnotationId);
                        // ...and start a new UFO press trace since the selected comment is changing
                        options.viewInlineCommentTraceUFOPress?.();
                    }
                    const { api: api } = options;
                    if (isDrafting && !view.state.selection.eq(_prevState.selection) && Boolean(api?.toolbar)) // It is possible that user update selection while having a active draft,
                    // so we need to reset the user intent to allow inline text toolbar to be visible
                    api?.core.actions.execute(({ tr: tr })=>{
                        if ((0, $bFFau.shouldSuppressFloatingToolbar)({
                            state: view.state,
                            bookmark: bookmark
                        })) (0, $8WyWb.setUserIntent)(api, tr);
                        else (0, $8WyWb.resetUserIntent)(api, tr);
                        return tr;
                    });
                    if (annotationManager) {
                        // In the Editor, Annotations can be selected in three ways:
                        // 1. By clicking on the annotation in the editor
                        // 2. By using the annotation manager to select the annotation
                        // 3. By moving the cursor to the annotation and using the keyboard to select it
                        // Item 1 & 3 need to be protected by the preemptive gate. This is because these actions could be performed by a user
                        // at a time when changing the selection could cause data loss.
                        // The following preemptive check is designed to cover these items.
                        const { pendingSelectedAnnotations: pendingSelectedAnnotations, pendingSelectedAnnotationsUpdateCount: pendingSelectedAnnotationsUpdateCount } = (0, $jCjGs.getPluginState)(view.state) || {};
                        const { pendingSelectedAnnotationsUpdateCount: prevPendingSelectedAnnotationsUpdateCount } = (0, $jCjGs.getPluginState)(_prevState) || {};
                        if (!isPreemptiveGateActive && pendingSelectedAnnotationsUpdateCount !== prevPendingSelectedAnnotationsUpdateCount && !!pendingSelectedAnnotations?.length) {
                            // Need to set a lock to avoid calling gate multiple times. The lock will be released
                            // when the preemptive gate is complete.
                            isPreemptiveGateActive = true;
                            annotationManager.checkPreemptiveGate().then((canSelectAnnotation)=>{
                                const { isDrafting: isDrafting, pendingSelectedAnnotations: latestPendingSelectedAnnotations, selectedAnnotations: latestSelectedAnnotations } = (0, $jCjGs.getPluginState)(view.state) || {};
                                if (canSelectAnnotation) {
                                    if (isDrafting) // The user must have chosen to discard there draft. So before we flush the pending selections
                                    // we need to clear the draft if there is one.
                                    (0, $5fWH4.setInlineCommentDraftState)(options.editorAnalyticsAPI, undefined, options.api)(false)(view.state, view.dispatch);
                                    // Flush the pending selections into the selected annotations list.
                                    (0, $5fWH4.flushPendingSelections)(options.editorAnalyticsAPI)(true)(view.state, view.dispatch);
                                    latestSelectedAnnotations?.filter((annotation)=>latestPendingSelectedAnnotations?.findIndex((pendingAnnotation)=>pendingAnnotation.id === annotation.id) === -1).forEach((annotation)=>{
                                        annotationManager.emit({
                                            name: 'annotationSelectionChanged',
                                            data: {
                                                annotationId: annotation.id,
                                                isSelected: false,
                                                inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                                            }
                                        });
                                    });
                                    // Notify the annotation manager that the pending selection has changed.
                                    latestPendingSelectedAnnotations?.forEach(({ id: id })=>{
                                        annotationManager.emit({
                                            name: 'annotationSelectionChanged',
                                            data: {
                                                annotationId: id,
                                                isSelected: true,
                                                inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(view.state, id) ?? []
                                            }
                                        });
                                    });
                                } else // Clears the pending selections if the preemptive gate returns false.
                                // We should need to worry about dispatching change events here because the pending selections
                                // are being aborted and the selections will remain unchanged.
                                (0, $5fWH4.flushPendingSelections)(options.editorAnalyticsAPI)(false)(view.state, view.dispatch);
                            }).catch((error)=>{
                                // If an error has occured we will clear any pending selections to avoid accidentally setting the wrong thing.
                                (0, $5fWH4.flushPendingSelections)(options.editorAnalyticsAPI)(false, 'pending-selection-preemptive-gate-error')(view.state, view.dispatch);
                            }).finally(()=>{
                                isPreemptiveGateActive = false;
                            });
                        }
                    }
                    const { dirtyAnnotations: dirtyAnnotations } = (0, $jCjGs.getPluginState)(view.state) || {};
                    if (!dirtyAnnotations) return;
                    (0, $5fWH4.clearDirtyMark)()(view.state, view.dispatch);
                    $5afcd16e23d3e19e$var$fetchState(provider, (0, $jCjGs.getAllAnnotations)(view.state.doc), view, options.editorAnalyticsAPI);
                },
                destroy () {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    editorView.root.removeEventListener('mouseup', mouseUp);
                    if (updateSubscriber) updateSubscriber.off('resolve', resolve).off('delete', resolve).off('unresolve', unResolve).off('create', unResolve).off('setvisibility', setVisibility).off('setselectedannotation', setSelectedAnnotationFn).off('sethoveredannotation', setHoveredAnnotationFn).off('removehoveredannotation', removeHoveredannotationFn).off('closeinlinecomment', closeInlineCommentFn);
                    if (annotationManager) {
                        annotationManager.unhook('allowAnnotation', allowAnnotationFn);
                        annotationManager.unhook('startDraft', startDraftFn);
                        annotationManager.unhook('clearDraft', clearDraftFn);
                        annotationManager.unhook('applyDraft', applyDraftFn);
                        annotationManager.unhook('getDraft', getDraftFn);
                        annotationManager.unhook('setIsAnnotationSelected', setIsAnnotationSelectedFn);
                        annotationManager.unhook('setIsAnnotationHovered', setIsAnnotationHoveredFn);
                        annotationManager.unhook('clearAnnotation', clearAnnotationFn);
                    }
                }
            };
        },
        props: {
            handleDOMEvents: {
                mousedown: (view)=>{
                    const pluginState = (0, $jCjGs.getPluginState)(view.state);
                    if (!pluginState?.mouseData.isSelecting) $5afcd16e23d3e19e$var$hideToolbar(view.state, view.dispatch)();
                    return false;
                },
                dragstart: (view, event)=>{
                    // Mouseup won't be triggered after dropping
                    // Hence, update the mouse data to cancel selecting when drag starts
                    return $5afcd16e23d3e19e$var$onMouseUp(view.state, view.dispatch)(event);
                },
                click: (view, event)=>{
                    if (!(event.target instanceof HTMLElement)) return false;
                    // Find the nearest ancestor (or self) with the data-id attribute
                    const annotationId = event.target.closest('[data-id]')?.getAttribute('data-id');
                    if (!annotationId) return false;
                    const pluginState = (0, $jCjGs.getPluginState)(view.state);
                    const isSelected = pluginState?.selectedAnnotations?.some((selectedAnnotation)=>selectedAnnotation.id === annotationId);
                    // If the annotation is selected and the inline comment view is open, do nothing
                    // as the user is already in the comment view.
                    if (isSelected && !pluginState?.isInlineCommentViewClosed) return false;
                    const { annotations: annotations } = pluginState || {};
                    const isUnresolved = annotations && annotations[annotationId] === false;
                    if (!isUnresolved) return false;
                    if (annotationManager) {
                        // The manager disable setting the selected annotation on click because in the editor this is already
                        // handled by the selection update handler. When the manager is enabled, and a selection changes it's pushed into
                        // the pendingSelectedAnnotations array. This is then used to update the selection when the preemptive gate
                        // is released.
                        const isPendingSelection = pluginState?.pendingSelectedAnnotations?.some((selectedAnnotation)=>selectedAnnotation.id === annotationId);
                        // If the annotation is selected and the inline comment view is open, do nothing
                        // as the user is already in the comment view.
                        if (isPendingSelection) return false;
                        (0, $5fWH4.setPendingSelectedAnnotation)(annotationId)(view.state, view.dispatch);
                    } else (0, $5fWH4.setSelectedAnnotation)(annotationId)(view.state, view.dispatch);
                    return true;
                }
            },
            decorations (state) {
                // highlight comments, depending on state
                const { draftDecorationSet: draftDecorationSet, annotations: annotations, selectedAnnotations: selectedAnnotations, isVisible: isVisible, isInlineCommentViewClosed: isInlineCommentViewClosed, hoveredAnnotations: hoveredAnnotations } = (0, $jCjGs.getPluginState)(state) || {};
                let decorations = draftDecorationSet ?? (0, $ftzrq.DecorationSet).empty;
                const focusDecorations = [];
                // TODO: EDITOR-760 - This needs to be optimised, it's not a good idea to scan the entire document
                // everytime we need to update the decorations. This handler will be called alot. We should be caching
                // the decorations in plugin state and only updating them when required.
                state.doc.descendants((node, pos)=>{
                    // Inline comment on mediaInline is not supported as part of comments on media project
                    // Thus, we skip the decoration for mediaInline node
                    if (node.type.name === 'mediaInline') return false;
                    const isSupportedBlockNode = node.isBlock && provider.supportedBlockNodes?.includes(node.type.name);
                    node.marks.filter((mark)=>mark.type === state.schema.marks.annotation).forEach((mark)=>{
                        if (isVisible) {
                            const isUnresolved = !!annotations && annotations[mark.attrs.id] === false;
                            const isSelected = !isInlineCommentViewClosed && !!selectedAnnotations?.some((selectedAnnotation)=>selectedAnnotation.id === mark.attrs.id);
                            const isHovered = !isInlineCommentViewClosed && !!hoveredAnnotations?.some((hoveredAnnotation)=>hoveredAnnotation.id === mark.attrs.id);
                            if (isSupportedBlockNode) focusDecorations.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
                                class: `${(0, $aN2Kl.getBlockAnnotationViewClassname)(isUnresolved, isSelected)} ${isUnresolved}`
                            }, {
                                key: (0, $jCjGs.decorationKey).block
                            }));
                            else if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
                                if (node.isText) focusDecorations.push((0, $ftzrq.Decoration).inline(pos, pos + node.nodeSize, {
                                    class: `${(0, $aN2Kl.getAnnotationViewClassname)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`,
                                    nodeName: 'span'
                                }));
                                else focusDecorations.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
                                    class: `${(0, $aN2Kl.getAnnotationViewClassname)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`
                                }, {
                                    key: (0, $jCjGs.decorationKey).block
                                }));
                            } else focusDecorations.push((0, $ftzrq.Decoration).inline(pos, pos + node.nodeSize, {
                                class: `${(0, $aN2Kl.getAnnotationViewClassname)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`,
                                nodeName: 'span'
                            }));
                        }
                    });
                });
                decorations = decorations.add(state.doc, focusDecorations);
                return decorations;
            }
        }
    });
};
module.exports["inlineCommentPlugin"] = $5afcd16e23d3e19e$export$e4aab3acac8f34b;

});

parcelRegister("aN2Kl", function(module, exports) {

var $6ESsx = parcelRequire("6ESsx");

const $e1a7a5099c215209$export$b3ab33741101ad90 = (isUnresolved, hasFocus, isHovered)=>{
    if (!isUnresolved) return;
    if (hasFocus) return (0, $6ESsx.AnnotationSharedClassNames).focus;
    if (isHovered) return (0, $6ESsx.AnnotationSharedClassNames).hover;
    return (0, $6ESsx.AnnotationSharedClassNames).blur;
};
const $e1a7a5099c215209$export$bb73203a2b3a63e2 = (isUnresolved, hasFocus)=>{
    if (!isUnresolved) return;
    return hasFocus ? (0, $6ESsx.BlockAnnotationSharedClassNames).focus : (0, $6ESsx.BlockAnnotationSharedClassNames).blur;
};
module.exports["getAnnotationViewClassname"] = $e1a7a5099c215209$export$b3ab33741101ad90;
module.exports["getBlockAnnotationViewClassname"] = $e1a7a5099c215209$export$bb73203a2b3a63e2;

});

parcelRegister("j5zAH", function(module, exports) {

var $cUycv = parcelRequire("cUycv");


var $bYZ53 = parcelRequire("bYZ53");


var $8m4tT = parcelRequire("8m4tT");


var $5fWH4 = parcelRequire("5fWH4");


var $6e47J = parcelRequire("6e47J");


var $jCjGs = parcelRequire("jCjGs");

const $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_NOT_STARTED = 'draft-not-started';
const $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_IN_PROGRESS = 'draft-in-progress';
const $21fc40f8bb03ab3c$var$ERROR_REASON_RANGE_MISSING = 'range-no-longer-exists';
const $21fc40f8bb03ab3c$var$ERROR_REASON_RANGE_INVALID = 'invalid-range';
const $21fc40f8bb03ab3c$var$ERROR_REASON_ID_INVALID = 'id-not-valid';
const $21fc40f8bb03ab3c$var$domRefFromPos = (view, position)=>{
    let dom;
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom = (0, $8m4tT.findDomRefAtPos)(position, view.domAtPos.bind(view));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        return undefined;
    }
    return dom;
};
const $21fc40f8bb03ab3c$export$86f3258f283eb796 = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $jCjGs.inlineCommentPluginKey).getState(editorView.state) || {};
        if (isDrafting) return false;
        const decoration = draftDecorationSet?.find();
        // If a draft decoration exists then we should block the user from creating a new one.
        if (!!decoration?.length) return false;
        return (0, $jCjGs.isSelectionValid)(editorView.state) === (0, $6e47J.AnnotationSelectionType).VALID;
    };
const $21fc40f8bb03ab3c$export$768048043e8d2bcd = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, selectedAnnotations: selectedAnnotations } = (0, $jCjGs.inlineCommentPluginKey).getState(editorView.state) || {};
        if (isDrafting) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_IN_PROGRESS
        };
        if (!!selectedAnnotations?.length) {
            // if there are selected annotations when starting a draft, we need to clear the selected annotations
            // before we start the draft.
            (0, $5fWH4.closeComponent)()(editorView.state, editorView.dispatch);
            // not only that but we need to also deselect any other annotations that are currently selected.
            selectedAnnotations?.forEach((annotation)=>{
                options.annotationManager?.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: annotation.id,
                        isSelected: false,
                        inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                    }
                });
            });
        }
        (0, $5fWH4.setInlineCommentDraftState)(options.editorAnalyticsAPI, undefined, options.api)(true)(editorView.state, editorView.dispatch);
        const { draftDecorationSet: draftDecorationSet } = (0, $jCjGs.inlineCommentPluginKey).getState(editorView.state) || {};
        const decorations = draftDecorationSet?.find();
        // If the matching decorations is not found containing the id, it means something went wrong with the draft.
        if (!decorations?.length) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_RANGE_INVALID
        };
        const from = decorations[0].from;
        const targetElement = $21fc40f8bb03ab3c$var$domRefFromPos(editorView, from);
        const inlineNodeTypes = (0, $bYZ53.getRangeInlineNodeNames)({
            doc: editorView.state.doc,
            pos: {
                from: from,
                to: decorations[decorations.length - 1].to
            }
        }) ?? [];
        options.annotationManager?.emit({
            name: 'draftAnnotationStarted',
            data: {
                targetElement: targetElement,
                actionResult: undefined,
                inlineNodeTypes: inlineNodeTypes
            }
        });
        return {
            success: true,
            targetElement: targetElement,
            // In Editor the action result is undefined, because the editor will perform the transaction on the document.
            actionResult: undefined,
            inlineNodeTypes: inlineNodeTypes
        };
    };
const $21fc40f8bb03ab3c$export$eeeb486534738631 = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $jCjGs.inlineCommentPluginKey).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet?.find();
        if (!decorations?.length) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        (0, $5fWH4.setInlineCommentDraftState)(options.editorAnalyticsAPI, undefined, options.api)(false)(editorView.state, editorView.dispatch);
        !editorView.hasFocus() && editorView.focus();
        return {
            success: true
        };
    };
const $21fc40f8bb03ab3c$export$8bc7b93e04771bda = (editorView, options)=>(id)=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet, bookmark: bookmark } = (0, $jCjGs.inlineCommentPluginKey).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet?.find();
        if (!decorations?.length || !bookmark) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_RANGE_MISSING
        };
        const from = decorations[0].from;
        (0, $5fWH4.createAnnotation)(options.editorAnalyticsAPI, options.api)(id, (0, $cUycv.AnnotationTypes).INLINE_COMMENT, options.provider.supportedBlockNodes)(editorView.state, editorView.dispatch);
        !editorView.hasFocus() && editorView.focus();
        // Using the original decoration from position we should be able to locate the new target element.
        // This is because the new annotation will be created at the same position as the draft decoration.
        const targetElement = $21fc40f8bb03ab3c$var$domRefFromPos(editorView, from);
        // When a draft is applied it is automatically selected, so we need to set the selected annotation.
        // emit the event for the selected annotation.
        options.annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: id,
                isSelected: true,
                inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
            }
        });
        return {
            success: true,
            targetElement: // Get the dom element from the newly created annotation and return it here.
            targetElement,
            // In Editor this is undefined, because the editor will update the document.
            actionResult: undefined
        };
    };
const $21fc40f8bb03ab3c$export$1a473231c51c1d5b = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $jCjGs.inlineCommentPluginKey).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet?.find();
        if (!decorations?.length) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const from = decorations[0].from;
        const targetElement = $21fc40f8bb03ab3c$var$domRefFromPos(editorView, from);
        const inlineNodeTypes = (0, $bYZ53.getRangeInlineNodeNames)({
            doc: editorView.state.doc,
            pos: {
                from: from,
                to: decorations[decorations.length - 1].to
            }
        }) ?? [];
        return {
            success: true,
            inlineNodeTypes: inlineNodeTypes,
            targetElement: targetElement,
            actionResult: undefined
        };
    };
const $21fc40f8bb03ab3c$export$b8ac6bdd928e737c = (editorView, options)=>(id, isSelected)=>{
        const { annotations: annotations, isDrafting: isDrafting, selectedAnnotations: selectedAnnotations } = (0, $jCjGs.inlineCommentPluginKey).getState(editorView.state) || {};
        if (isDrafting) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_DRAFT_IN_PROGRESS
        };
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!annotations?.hasOwnProperty(id)) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_ID_INVALID
        };
        const isCurrentlySelectedIndex = selectedAnnotations?.findIndex((annotation)=>annotation.id === id) ?? -1;
        const isCurrentlySelected = isCurrentlySelectedIndex !== -1;
        if (isSelected !== isCurrentlySelected) {
            // the annotation is selection is changing.
            if (isCurrentlySelected && !isSelected) {
                // the selected annotaion is being unselected, so we need to close the view.
                (0, $5fWH4.closeComponent)()(editorView.state, editorView.dispatch);
                options.annotationManager?.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: id,
                        isSelected: false,
                        inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
                    }
                });
            } else if (!isCurrentlySelected && isSelected) {
                // the annotation is currently not selected and is being selected, so we need to open the view.
                (0, $5fWH4.setSelectedAnnotation)(id)(editorView.state, editorView.dispatch);
                // the current annotations are going to be unselected. So we need to notify listeners of this change also.
                selectedAnnotations?.forEach((annotation)=>{
                    if (annotation.id !== id) options.annotationManager?.emit({
                        name: 'annotationSelectionChanged',
                        data: {
                            annotationId: annotation.id,
                            isSelected: false,
                            inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                        }
                    });
                });
                // Lastly we need to emit the event for the selected annotation.
                options.annotationManager?.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: id,
                        isSelected: true,
                        inlineNodeTypes: (0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
                    }
                });
            }
        }
        return {
            success: true,
            isSelected: isSelected
        };
    };
const $21fc40f8bb03ab3c$export$5ada3da2e2f0701f = (editorView, options)=>(id, isHovered)=>{
        const { annotations: annotations, hoveredAnnotations: hoveredAnnotations } = (0, $jCjGs.inlineCommentPluginKey).getState(editorView.state) || {};
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!annotations?.hasOwnProperty(id)) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_ID_INVALID
        };
        const isCurrentlyHoveredIndex = hoveredAnnotations?.findIndex((annotation)=>annotation.id === id) ?? -1;
        const isCurrentlyHovered = isCurrentlyHoveredIndex !== -1;
        if (isHovered !== isCurrentlyHovered) {
            // the annotation in hovered is changing.
            if (isCurrentlyHovered && !isHovered) // the hovered annotaion is being unhovered, so we should remove the hover state.
            (0, $5fWH4.setHoveredAnnotation)('')(editorView.state, editorView.dispatch);
            else if (!isCurrentlyHovered && isHovered) // the annotation is currently not hovered and is being hovered.
            (0, $5fWH4.setHoveredAnnotation)(id)(editorView.state, editorView.dispatch);
        }
        return {
            success: true,
            isHovered: isHovered
        };
    };
const $21fc40f8bb03ab3c$export$6baae9b3f0f9bdce = (editorView, options)=>(id)=>{
        const { annotations: annotations } = (0, $jCjGs.inlineCommentPluginKey).getState(editorView.state) || {};
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!annotations?.hasOwnProperty(id)) return {
            success: false,
            reason: $21fc40f8bb03ab3c$var$ERROR_REASON_ID_INVALID
        };
        (0, $5fWH4.removeInlineCommentFromDoc)(options.editorAnalyticsAPI)(id, options.provider.supportedBlockNodes)(editorView.state, editorView.dispatch);
        return {
            success: true,
            actionResult: undefined
        };
    };
module.exports["allowAnnotation"] = $21fc40f8bb03ab3c$export$86f3258f283eb796;
module.exports["startDraft"] = $21fc40f8bb03ab3c$export$768048043e8d2bcd;
module.exports["clearDraft"] = $21fc40f8bb03ab3c$export$eeeb486534738631;
module.exports["applyDraft"] = $21fc40f8bb03ab3c$export$8bc7b93e04771bda;
module.exports["getDraft"] = $21fc40f8bb03ab3c$export$1a473231c51c1d5b;
module.exports["setIsAnnotationSelected"] = $21fc40f8bb03ab3c$export$b8ac6bdd928e737c;
module.exports["setIsAnnotationHovered"] = $21fc40f8bb03ab3c$export$5ada3da2e2f0701f;
module.exports["clearAnnotation"] = $21fc40f8bb03ab3c$export$6baae9b3f0f9bdce;

});

parcelRegister("bFFau", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");

var $e2wMq = parcelRequire("e2wMq");


var $hgeg8 = parcelRequire("hgeg8");


var $kfJSC = parcelRequire("kfJSC");


var $ahUGI = parcelRequire("ahUGI");


var $lNDSG = parcelRequire("lNDSG");

var $bYZ53 = parcelRequire("bYZ53");


var $91bcx = parcelRequire("91bcx");


var $1yB28 = parcelRequire("1yB28");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $5fWH4 = parcelRequire("5fWH4");


var $6e47J = parcelRequire("6e47J");


var $jCjGs = parcelRequire("jCjGs");

const $9b6a63f7e792d6b0$var$getValidNodes = (state)=>{
    const { schema: schema } = state;
    const { annotation: annotation } = schema.marks;
    return Object.keys(schema.nodes).reduce((acc, current)=>{
        const type = schema.nodes[current];
        if (type.allowsMarkType(annotation)) acc.push(type);
        return acc;
    }, []);
};
const $9b6a63f7e792d6b0$export$8921e02ce71849ce = ({ state: state, bookmark: bookmark })=>{
    if (!bookmark) return false;
    const { tr: tr } = state;
    const resolvedBookmark = bookmark.resolve(tr.doc);
    const isSelectionMatchingBookmark = resolvedBookmark.to === tr.selection.to && resolvedBookmark.from === tr.selection.from;
    return isSelectionMatchingBookmark;
};
const $9b6a63f7e792d6b0$export$4f0bdd9681380033 = (state, api)=>{
    const userIntentEnabled = Boolean(api?.userIntent && (0, $1oCLl.expValEquals)('platform_editor_lovability_user_intent', 'isEnabled', true));
    return {
        items: [],
        nodeType: $9b6a63f7e792d6b0$var$getValidNodes(state),
        title: 'Annotation suppressed toolbar',
        __suppressAllToolbars: userIntentEnabled ? undefined : true
    };
};
const $9b6a63f7e792d6b0$export$6dd6ab35df8f7f86 = (editorAnalyticsAPI)=>({ state: state, intl: intl, isToolbarAbove: isToolbarAbove = false, _supportedNodes: _supportedNodes = [], api: api, createCommentExperience: createCommentExperience, annotationManager: annotationManager, onCommentButtonMount: onCommentButtonMount, getCanAddComments: getCanAddComments = ()=>true, contentType: contentType })=>{
        const selectionValid = (0, $jCjGs.isSelectionValid)(state);
        const isMediaSelected = (0, $kfJSC.currentMediaNodeWithPos)(state);
        // comments on media can only be added via media floating toolbar
        if (isMediaSelected || selectionValid === (0, $6e47J.AnnotationSelectionType).INVALID) return undefined;
        const createCommentMessage = intl.formatMessage((0, $ahUGI.annotationMessages).createComment);
        const commentDisabledMessage = intl.formatMessage((0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? (0, $ahUGI.annotationMessages).createCommentDisabled : (0, $ahUGI.annotationMessages).createCommentInvalid);
        const canAddComments = getCanAddComments();
        const isCommentButtonDisabled = !canAddComments || selectionValid === (0, $6e47J.AnnotationSelectionType).DISABLED;
        const disabledTooltipContent = !canAddComments ? intl.formatMessage((0, $ahUGI.annotationMessages).noPermissionToAddComment, {
            contentType: contentType
        }) : commentDisabledMessage;
        const createComment = {
            type: 'button',
            showTitle: true,
            disabled: isCommentButtonDisabled || (0, $91bcx.isOfflineMode)(api?.connectivity?.sharedState?.currentState()?.mode),
            testId: (0, $6e47J.AnnotationTestIds).floatingToolbarCreateButton,
            interactionName: 'start-inline-comment-action',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
            tooltipContent: isCommentButtonDisabled ? disabledTooltipContent : /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
                description: createCommentMessage,
                keymap: (0, $hgeg8.addInlineComment)
            }),
            title: createCommentMessage,
            onMount: ()=>{
                if ((0, $dh538.fg)('confluence_frontend_preload_inline_comment_editor')) onCommentButtonMount && onCommentButtonMount();
                // Check if the selection includes an non-text inline node
                const inlineCommentPluginState = (0, $jCjGs.getPluginState)(state);
                const inlineNodeNames = (0, $bYZ53.getRangeInlineNodeNames)({
                    doc: state.doc,
                    pos: (0, $jCjGs.resolveDraftBookmark)(state, inlineCommentPluginState?.bookmark)
                }) ?? [];
                const isNonTextInlineNodeInludedInComment = inlineNodeNames.filter((nodeName)=>nodeName !== 'text').length > 0;
                if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).VIEWED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, $d925B.EVENT_TYPE).UI,
                    attributes: {
                        isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
                        isDisabled: selectionValid === (0, $6e47J.AnnotationSelectionType).DISABLED,
                        inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                        mode: (0, $e2wMq.MODE).EDITOR
                    }
                });
            },
            onClick: (state, dispatch)=>{
                editorAnalyticsAPI?.fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).CLICKED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                    eventType: (0, $d925B.EVENT_TYPE).UI,
                    attributes: {
                        source: 'highlightActionsMenu',
                        pageMode: 'edit'
                    }
                });
                if (annotationManager) {
                    annotationManager.checkPreemptiveGate().then((canStartDraft)=>{
                        if (canStartDraft) {
                            createCommentExperience?.start({
                                attributes: {
                                    pageClass: 'editor',
                                    commentType: 'inline',
                                    entryPoint: 'highlightActions'
                                }
                            });
                            createCommentExperience?.initExperience.start();
                            const result = annotationManager.startDraft();
                            if (!result.success) // Fire an analytics event to indicate that the user has clicked the button
                            // but the action was not completed, the result should contain a reason.
                            editorAnalyticsAPI?.fireAnalyticsEvent({
                                action: (0, $d925B.ACTION).ERROR,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    errorReason: `toolbar-start-draft-failed/${result.reason}`
                                }
                            });
                        }
                    }).catch(()=>{
                        editorAnalyticsAPI?.fireAnalyticsEvent({
                            action: (0, $d925B.ACTION).ERROR,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                            attributes: {
                                errorReason: `toolbar-start-draft-preemptive-gate-error`
                            }
                        });
                    });
                    return true;
                } else {
                    createCommentExperience?.start({
                        attributes: {
                            pageClass: 'editor',
                            commentType: 'inline',
                            entryPoint: 'highlightActions'
                        }
                    });
                    createCommentExperience?.initExperience.start();
                    return (0, $5fWH4.setInlineCommentDraftState)(editorAnalyticsAPI)(true)(state, dispatch);
                }
            },
            supportsViewMode: true // TODO: MODES-3950 - Clean up this floating toolbar view mode logic,
        };
        const toolbarTitle = intl.formatMessage((0, $ahUGI.annotationMessages).toolbar);
        const calcToolbarPosition = isToolbarAbove ? (0, $lNDSG.calculateToolbarPositionAboveSelection) : (0, $lNDSG.calculateToolbarPositionTrackHead);
        const onPositionCalculated = calcToolbarPosition(toolbarTitle);
        return {
            title: toolbarTitle,
            nodeType: $9b6a63f7e792d6b0$var$getValidNodes(state),
            items: [
                createComment
            ],
            onPositionCalculated: onPositionCalculated,
            pluginName: 'annotation'
        };
    };
module.exports["shouldSuppressFloatingToolbar"] = $9b6a63f7e792d6b0$export$8921e02ce71849ce;
module.exports["buildSuppressedToolbar"] = $9b6a63f7e792d6b0$export$4f0bdd9681380033;
module.exports["buildToolbar"] = $9b6a63f7e792d6b0$export$6dd6ab35df8f7f86;

});

parcelRegister("1hrpf", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $dus6D = parcelRequire("dus6D");


var $5fWH4 = parcelRequire("5fWH4");

function $d92abb614d3b39aa$export$e832373cff8dec22(api) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addInlineComment).common, (0, $5fWH4.setInlineCommentDraftState)(api?.analytics?.actions, undefined, api)(true, (0, $d925B.INPUT_METHOD).SHORTCUT), list);
    return (0, $dus6D.keymap)(list);
}
module.exports["keymapPlugin"] = $d92abb614d3b39aa$export$e832373cff8dec22;

});

parcelRegister("cCuH1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cUycv = parcelRequire("cUycv");


var $d925B = parcelRequire("d925B");

var $55QXP = parcelRequire("55QXP");


var $eiA8Z = parcelRequire("eiA8Z");


var $b3YrF = parcelRequire("b3YrF");


var $bYZ53 = parcelRequire("bYZ53");


var $91bcx = parcelRequire("91bcx");


var $8m4tT = parcelRequire("8m4tT");


var $iu6m9 = parcelRequire("iu6m9");


var $5fWH4 = parcelRequire("5fWH4");


var $jCjGs = parcelRequire("jCjGs");


var $6e47J = parcelRequire("6e47J");


var $2e9PN = parcelRequire("2e9PN");

const $ae02a84cba9b2c8c$var$findPosForDOM = (sel)=>{
    const { $from: $from, from: from } = sel;
    // Retrieve current TextNode
    const index = $from.index();
    const node = index < $from.parent.childCount && $from.parent.child(index);
    // Right edge of a mark.
    if (!node && $from.nodeBefore && $from.nodeBefore.isText && $from.nodeBefore.marks.find((mark)=>mark.type.name === 'annotation')) return from - 1;
    return from;
};
const $ae02a84cba9b2c8c$var$selector = (states)=>{
    return {
        annotations: states.annotationState?.annotations,
        bookmark: states.annotationState?.bookmark,
        isInlineCommentViewClosed: states.annotationState?.isInlineCommentViewClosed,
        isOpeningMediaCommentFromToolbar: states.annotationState?.isOpeningMediaCommentFromToolbar,
        selectAnnotationMethod: states.annotationState?.selectAnnotationMethod,
        selectedAnnotations: states.annotationState?.selectedAnnotations,
        isAnnotationManagerEnabled: states.annotationState?.isAnnotationManagerEnabled
    };
};
function $ae02a84cba9b2c8c$export$ce99d9856d415465({ providers: providers, editorView: editorView, editorAnalyticsAPI: editorAnalyticsAPI, editorAPI: editorAPI, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    // As inlineComment is the only annotation present, this function is not generic
    const { inlineComment: inlineCommentProvider } = providers;
    const { state: state, dispatch: dispatch } = editorView;
    const lastSelectedAnnotationId = (0, $42omo.useRef)();
    const { createComponent: CreateComponent, viewComponent: ViewComponent } = inlineCommentProvider;
    const { annotations: annotations, bookmark: bookmark, isInlineCommentViewClosed: isInlineCommentViewClosed, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, selectAnnotationMethod: selectAnnotationMethod, selectedAnnotations: selectedAnnotations, isAnnotationManagerEnabled: isAnnotationManagerEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'annotation'
    ], $ae02a84cba9b2c8c$var$selector);
    const annotationsList = (0, $jCjGs.getAllAnnotations)(editorView.state.doc);
    const selection = (0, $jCjGs.getSelectionPositions)(state, bookmark);
    const position = $ae02a84cba9b2c8c$var$findPosForDOM(selection);
    let dom;
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom = (0, $8m4tT.findDomRefAtPos)(position, editorView.domAtPos.bind(editorView));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $d925B.CONTENT_COMPONENT).INLINE_COMMENT,
                    selection: selection.toJSON(),
                    position: position,
                    docSize: editorView.state.doc.nodeSize,
                    error: error.toString()
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
    // Network Status
    const networkStatusSelector = (0, $b3YrF.useSharedPluginStateSelector)(editorAPI, 'connectivity.mode', {
        disabled: (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', false)
    });
    if (!dom) return null;
    // Create Component
    if (bookmark) {
        if (!CreateComponent) return null;
        const currentlySelectedAnnotation = selectedAnnotations?.[0]?.id;
        const isAnnotationSelectionChanged = currentlySelectedAnnotation !== lastSelectedAnnotationId.current;
        // Update the last selected annotation ID if the selection was updated
        if (isAnnotationSelectionChanged) lastSelectedAnnotationId.current = currentlySelectedAnnotation;
        const inlineNodeTypes = (0, $bYZ53.getRangeInlineNodeNames)({
            doc: state.doc,
            pos: selection
        });
        //getting all text between bookmarked positions
        const textSelection = state.doc.textBetween(selection.from, selection.to);
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": (0, $6e47J.AnnotationTestIds).floatingComponent,
            "data-editor-popup": "true",
            children: /*#__PURE__*/ (0, $l998X.jsx)(CreateComponent, {
                dom: dom,
                textSelection: textSelection,
                wasNewAnnotationSelected: !!currentlySelectedAnnotation && isAnnotationSelectionChanged,
                onCreate: (id)=>{
                    if (!isAnnotationManagerEnabled) {
                        const createAnnotationResult = (0, $5fWH4.createAnnotation)(editorAnalyticsAPI, editorAPI)(id, (0, $cUycv.AnnotationTypes).INLINE_COMMENT, inlineCommentProvider.supportedBlockNodes)(editorView.state, editorView.dispatch);
                        !editorView.hasFocus() && editorView.focus();
                        if (!createAnnotationResult) throw new Error('Failed to create annotation');
                    }
                },
                onClose: ()=>{
                    if (!isAnnotationManagerEnabled) {
                        (0, $5fWH4.setInlineCommentDraftState)(editorAnalyticsAPI, undefined, editorAPI)(false)(editorView.state, editorView.dispatch);
                        !editorView.hasFocus() && editorView.focus();
                    }
                },
                inlineNodeTypes: inlineNodeTypes,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
                isOffline: (0, $91bcx.isOfflineMode)(networkStatusSelector)
            })
        });
    }
    // View Component
    const activeAnnotations = selectedAnnotations?.filter((mark)=>annotations && annotations[mark.id] === false) || [];
    if (!ViewComponent || activeAnnotations.length === 0) return null;
    const onAnnotationViewed = ()=>{
        if (!dispatchAnalyticsEvent) return;
        // fire analytics
        const payload = {
            action: (0, $d925B.ACTION).VIEWED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                overlap: activeAnnotations.length ? activeAnnotations.length - 1 : 0,
                targetNodeType: editorView.state.doc.nodeAt(position)?.type.name,
                method: selectAnnotationMethod
            }
        };
        dispatchAnalyticsEvent(payload);
    };
    if (isInlineCommentViewClosed || !selectedAnnotations) return null;
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (annotationId)=>(0, $bYZ53.getAnnotationInlineNodeTypes)(editorView.state, annotationId);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2e9PN.AnnotationViewWrapper), {
        "data-editor-popup": "true",
        "data-testid": (0, $6e47J.AnnotationTestIds).floatingComponent,
        onViewed: onAnnotationViewed,
        children: /*#__PURE__*/ (0, $l998X.jsx)(ViewComponent, {
            annotationsList: annotationsList,
            annotations: activeAnnotations,
            getInlineNodeTypes: getInlineNodeTypes,
            dom: dom,
            onDelete: (id)=>(0, $5fWH4.removeInlineCommentNearSelection)(id, inlineCommentProvider.supportedBlockNodes)(editorView.state, dispatch),
            onResolve: (id)=>(0, $5fWH4.updateInlineCommentResolvedState)(editorAnalyticsAPI)({
                    [id]: true
                }, (0, $55QXP.RESOLVE_METHOD).COMPONENT)(editorView.state, editorView.dispatch),
            onClose: ()=>{
                (0, $5fWH4.closeComponent)()(editorView.state, editorView.dispatch);
            },
            isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
            isOffline: (0, $91bcx.isOfflineMode)(networkStatusSelector)
        })
    }, (0, $jCjGs.getAnnotationViewKey)(activeAnnotations));
}
module.exports["InlineCommentView"] = $ae02a84cba9b2c8c$export$ce99d9856d415465;

});

parcelRegister("2e9PN", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $6042d03a98409edf$export$1fe5705f230796ba extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        const { onViewed: onViewed } = this.props;
        if (onViewed) onViewed();
    }
    render() {
        return this.props.children;
    }
}
module.exports["AnnotationViewWrapper"] = $6042d03a98409edf$export$1fe5705f230796ba;

});

parcelRegister("iPrfA", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $30b35 = parcelRequire("30b35");

const $8fb9dc28a8dbe648$export$a758406ca53b86a5 = (api, annotationProviders)=>{
    return [
        {
            type: (0, $cPCP8.COLLAB_SECTION).type,
            key: (0, $cPCP8.COLLAB_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.COLLAB_SECTION).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.COMMENT_GROUP).type,
            key: (0, $cPCP8.COMMENT_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.COLLAB_SECTION).type,
                    key: (0, $cPCP8.COLLAB_SECTION).key,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.COLLAB_SECTION).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.COMMENT_HERO_BUTTON).type,
            key: (0, $cPCP8.COMMENT_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.COMMENT_GROUP).type,
                    key: (0, $cPCP8.COMMENT_GROUP).key,
                    rank: (0, $4Chin.COLLAB_SECTION_RANK)[(0, $cPCP8.COMMENT_GROUP).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $30b35.CommentButton), {
                    api: api,
                    annotationProviders: annotationProviders
                });
            }
        }
    ];
};
module.exports["getToolbarComponents"] = $8fb9dc28a8dbe648$export$a758406ca53b86a5;

});

parcelRegister("30b35", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $hgeg8 = parcelRequire("hgeg8");


var $ahUGI = parcelRequire("ahUGI");


var $gzUv9 = parcelRequire("gzUv9");


var $b3YrF = parcelRequire("b3YrF");


var $1yB28 = parcelRequire("1yB28");

var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");


var $dh538 = parcelRequire("dh538");


var $jCjGs = parcelRequire("jCjGs");


var $6e47J = parcelRequire("6e47J");


var $1pR2p = parcelRequire("1pR2p");


var $6WjaI = parcelRequire("6WjaI");

const $2a7c42f5944ba88b$export$44a3d5aec3da3e9f = ({ api: api, annotationProviders: annotationProviders })=>{
    const isVisible = (0, $b3YrF.useSharedPluginStateSelector)(api, 'annotation.isVisible');
    const bookmark = (0, $b3YrF.useSharedPluginStateSelector)(api, 'annotation.bookmark');
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    const annotationSelectionType = editorView?.state ? (0, $jCjGs.isSelectionValid)(editorView.state) : (0, $6e47J.AnnotationSelectionType).INVALID;
    const { getCanAddComments: getCanAddComments, contentType: contentType } = annotationProviders?.inlineComment ?? {};
    (0, $1pR2p.useCommentButtonMount)({
        state: editorView?.state,
        annotationProviders: annotationProviders,
        api: api,
        annotationSelectionType: annotationSelectionType,
        bookmark: bookmark
    });
    const intl = (0, $8C5kA.default)();
    const onClick = ()=>{
        if (!api || !annotationProviders || !editorView?.state || !editorView?.dispatch) return;
        (0, $6WjaI.fireOnClickAnalyticsEvent)({
            api: api
        });
        (0, $6WjaI.startCommentExperience)({
            annotationProviders: annotationProviders,
            api: api,
            state: editorView.state,
            dispatch: editorView.dispatch
        });
    };
    if (!(0, $6WjaI.shouldShowCommentButton)({
        state: editorView?.state,
        isVisible: isVisible,
        annotationSelectionType: annotationSelectionType
    })) return null;
    const canAddComments = getCanAddComments ? getCanAddComments() : true;
    const commentMessage = intl.formatMessage((0, $ahUGI.annotationMessages).createComment);
    const commentDisabledMessage = intl.formatMessage((0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? (0, $ahUGI.annotationMessages).createCommentDisabled : (0, $ahUGI.annotationMessages).createCommentInvalid);
    const noPermissionToAddCommentMessage = intl.formatMessage((0, $ahUGI.annotationMessages).noPermissionToAddComment, {
        contentType: contentType
    });
    const isDisabled = (0, $6WjaI.isButtonDisabled)({
        state: editorView?.state,
        api: api,
        canAddComments: canAddComments
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: isDisabled ? !canAddComments ? noPermissionToAddCommentMessage : commentDisabledMessage : /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
            description: commentMessage,
            keymap: (0, $hgeg8.addInlineComment)
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                label: "",
                size: "small"
            }),
            onClick: onClick,
            testId: (0, $6e47J.AnnotationTestIds).floatingToolbarCreateButton,
            isDisabled: isDisabled,
            children: commentMessage
        })
    });
};
module.exports["CommentButton"] = $2a7c42f5944ba88b$export$44a3d5aec3da3e9f;

});

parcelRegister("1pR2p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bYZ53 = parcelRequire("bYZ53");


var $dh538 = parcelRequire("dh538");


var $jCjGs = parcelRequire("jCjGs");


var $6WjaI = parcelRequire("6WjaI");

const $4c16e01fcbc0489f$export$b0b121505277a396 = ({ state: state, annotationProviders: annotationProviders, api: api, annotationSelectionType: annotationSelectionType, bookmark: bookmark })=>{
    (0, $42omo.useEffect)(()=>{
        if (!state) return;
        if (annotationProviders?.inlineComment && (0, $dh538.fg)('confluence_frontend_preload_inline_comment_editor')) annotationProviders.inlineComment.onCommentButtonMount?.();
        // Check if the selection includes an non-text inline node
        const inlineNodeNames = (0, $bYZ53.getRangeInlineNodeNames)({
            doc: state.doc,
            pos: (0, $jCjGs.resolveDraftBookmark)(state, bookmark)
        }) ?? [];
        const isNonTextInlineNodeInludedInComment = inlineNodeNames.filter((nodeName)=>nodeName !== 'text').length > 0;
        (0, $6WjaI.fireCommentButtonViewedAnalyticsEvent)({
            api: api,
            isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
            annotationSelectionType: annotationSelectionType
        });
    // for now trying to replicate current onMount logic
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
module.exports["useCommentButtonMount"] = $4c16e01fcbc0489f$export$b0b121505277a396;

});

parcelRegister("6WjaI", function(module, exports) {

var $d925B = parcelRequire("d925B");

var $e2wMq = parcelRequire("e2wMq");


var $kfJSC = parcelRequire("kfJSC");


var $91bcx = parcelRequire("91bcx");


var $5fWH4 = parcelRequire("5fWH4");


var $jCjGs = parcelRequire("jCjGs");


var $6e47J = parcelRequire("6e47J");

const $74d3c5d57fc803d2$export$7a6737b74121da6f = ({ state: state, api: api, canAddComments: canAddComments })=>{
    const annotationSelectionType = state ? (0, $jCjGs.isSelectionValid)(state) : (0, $6e47J.AnnotationSelectionType).INVALID;
    return !canAddComments || annotationSelectionType === (0, $6e47J.AnnotationSelectionType).DISABLED || (0, $91bcx.isOfflineMode)(api?.connectivity?.sharedState?.currentState()?.mode);
};
const $74d3c5d57fc803d2$export$dd62b022312fd583 = ({ state: state, isVisible: isVisible, annotationSelectionType: annotationSelectionType })=>{
    const isMediaSelected = state ? (0, $kfJSC.currentMediaNodeWithPos)(state) : false;
    let isDrafting = false;
    if (state) isDrafting = (0, $jCjGs.inlineCommentPluginKey).getState(state)?.isDrafting || false;
    // comments on media can only be added via media floating toolbar
    if (isDrafting || isMediaSelected || annotationSelectionType === (0, $6e47J.AnnotationSelectionType).INVALID || !isVisible) return false;
    return true;
};
const $74d3c5d57fc803d2$export$b5fd00fffbd8948d = ({ api: api })=>{
    api.analytics?.actions.fireAnalyticsEvent({
        action: (0, $d925B.ACTION).CLICKED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            source: 'highlightActionsMenu',
            pageMode: 'edit'
        }
    });
};
const $74d3c5d57fc803d2$var$fireAnnotationErrorAnalyticsEvent = ({ api: api, errorReason: errorReason })=>{
    api.analytics?.actions?.fireAnalyticsEvent({
        action: (0, $d925B.ACTION).ERROR,
        actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorReason: errorReason
        }
    });
};
const $74d3c5d57fc803d2$export$aa79a97671c224b4 = ({ api: api, isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment, annotationSelectionType: annotationSelectionType })=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $d925B.ACTION).VIEWED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
            isDisabled: annotationSelectionType === (0, $6e47J.AnnotationSelectionType).DISABLED,
            inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
            mode: (0, $e2wMq.MODE).EDITOR
        }
    });
};
const $74d3c5d57fc803d2$export$c983cfb71edde6e4 = ({ annotationProviders: annotationProviders, api: api, state: state, dispatch: dispatch })=>{
    const annotationManager = annotationProviders?.annotationManager;
    if (annotationManager) {
        annotationManager.checkPreemptiveGate().then((canStartDraft)=>{
            if (canStartDraft) {
                annotationProviders.createCommentExperience?.start({
                    attributes: {
                        pageClass: 'editor',
                        commentType: 'inline',
                        entryPoint: 'highlightActions'
                    }
                });
                annotationProviders.createCommentExperience?.initExperience.start();
                const result = annotationManager.startDraft();
                if (!result.success) // Fire an analytics event to indicate that the user has clicked the button
                // but the action was not completed, the result should contain a reason.
                $74d3c5d57fc803d2$var$fireAnnotationErrorAnalyticsEvent({
                    api: api,
                    errorReason: `toolbar-start-draft-failed/${result.reason}`
                });
            }
        }).catch(()=>{
            $74d3c5d57fc803d2$var$fireAnnotationErrorAnalyticsEvent({
                api: api,
                errorReason: `toolbar-start-draft-preemptive-gate-error`
            });
        });
        return true;
    } else {
        annotationProviders?.createCommentExperience?.start({
            attributes: {
                pageClass: 'editor',
                commentType: 'inline',
                entryPoint: 'highlightActions'
            }
        });
        annotationProviders?.createCommentExperience?.initExperience.start();
        return (0, $5fWH4.setInlineCommentDraftState)(api?.analytics?.actions, undefined, api)(true)(state, dispatch);
    }
};
module.exports["isButtonDisabled"] = $74d3c5d57fc803d2$export$7a6737b74121da6f;
module.exports["shouldShowCommentButton"] = $74d3c5d57fc803d2$export$dd62b022312fd583;
module.exports["fireOnClickAnalyticsEvent"] = $74d3c5d57fc803d2$export$b5fd00fffbd8948d;
module.exports["fireCommentButtonViewedAnalyticsEvent"] = $74d3c5d57fc803d2$export$aa79a97671c224b4;
module.exports["startCommentExperience"] = $74d3c5d57fc803d2$export$c983cfb71edde6e4;

});

parcelRegister("25jxS", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ var $659c2425e3733293$export$d173f08296df529 = /*#__PURE__*/ function(NCS_STORAGE) {
    NCS_STORAGE["NCS_STORAGE_CLIENT_KEY"] = "ncs-session-step-metrics-storage";
    NCS_STORAGE["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    NCS_STORAGE["NCS_ACTIVE_SESSIONS"] = "ncsActiveSessions";
    return NCS_STORAGE;
}({});
module.exports["NCS_STORAGE"] = $659c2425e3733293$export$d173f08296df529;

});


$parcel$global.rlb("5S8LV")
//# sourceMappingURL=CommentEditor.74dab9e1.js.map
